// import React, { useState } from "react";
// import { API } from "../../../config/api";
// import { post } from "../../../lib/http";
// import { FaPlus, FaTrash, FaSpinner, FaCheckCircle, FaTimesCircle } from "react-icons/fa";


// const toDTLocal = (d) => {
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
// };


// export default function AdminEventForm() {
//   const [form, setForm] = useState({
//     name: "",
//     category: "Music",
//     description: "",
//     venue: {
//       name: "",
//       address: "",
//       city: "",
//       state: "",
//       country: "",
//       pincode: "",
//       latitude: "",
//       longitude: "",
//       capacity: "",
//       logoUrl: ""
//     },
//     date: "",
//     eventEndDate: "",
//     ticketCategories: [
//       { type: "", price: "", currency: "INR", totalSeats: "", availableSeats: "", perks: [""] },
//     ],
//     showtimes: [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
//     imageUrl: "",
//     landsacpImage: [""],
//     status: "Upcoming",
//     organizer: { name: "", contactEmail: "", contactPhone: "", website: "", logoUrl: "" },
//     termsAndConditions: [{ point: "" }],
//     ratings: { averageRating: 0, totalReviews: 0 },
//     isVerified: false,
//     isBookingOpen:true,
//     isActived: true,
//     remark: "",
//     tags: [""],
//     sponsors: [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
//     ageRestriction: "",
//     language: "",
//     duration: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");
//   const [uploadProgress, setUploadProgress] = useState({});

//   const now = new Date();
//   const startOfTomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
//   const minEventDate = toDTLocal(startOfTomorrow);

//   const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));
//   const onNestedChange = (parent, key, value) =>
//     setForm((f) => ({ ...f, [parent]: { ...f[parent], [key]: value } }));

//   const onArrayChange = (arrKey, index, key, value) => {
//     const updated = [...form[arrKey]];
//     updated[index][key] = value;
//     setForm((f) => ({ ...f, [arrKey]: updated }));
//   };


//   const addArrayItem = (arrKey, newItem) =>
//     setForm((f) => ({ ...f, [arrKey]: [...f[arrKey], newItem] }));
//   const removeArrayItem = (arrKey, index) =>
//     setForm((f) => ({ ...f, [arrKey]: f[arrKey].filter((_, i) => i !== index) }));

//   const uploadFileAndGetUrl = async (file, index = null) => {
//     if (!file) return "";
//     const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//     const fd = new FormData();
//     fd.append("file", file);
//     // setUploadProgress((p) => ({ ...p, [key ?? "poster"]: 0 }));
//     const resp = await post(API.events.fileUploader, fd, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     // const resp = await fetch(`${API.events.fileUploader}`, {
//     //   method: "POST",
//     //   headers: { Authorization: `Bearer ${token}` },
//     //   body: fd,
//     // });

//     // const data = await resp.json().catch(() => ({}));
//     // setUploadProgress((p) => ({ ...p, [key ?? "poster"]: 100 }));

//     if (!resp.success) {
//       throw new Error(resp?.message || "Upload failed");
//     }
//     const url =
//       resp?.url ||
//       resp?.resp?.url ||
//       resp?.fileUrl ||
//       resp?.location ||
//       resp?.path ||
//       resp?.secure_url ||
//       "";
//     if (!url) throw new Error("Upload success but no URL found in response.");
//     return url;
//   };

//   const handlePosterFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading poster...");
//       const url = await uploadFileAndGetUrl(file);
//       onChange("imageUrl", url);
//       setMessage("✅ Poster uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Poster upload failed.");
//     }
//   };

//   const handleLandscapeFile = async (e, index) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage(`Uploading landscape image ${index + 1}...`);
//       const url = await uploadFileAndGetUrl(file, `landscape-${index}`);
//       const imgs = [...form.landsacpImage];
//       imgs[index] = url;
//       onChange("landsacpImage", imgs);
//       setMessage("✅ Landscape image uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Landscape upload failed.");
//     }
//   };

//   const handleSponsorLogoFile = async (e, index) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage(`Uploading sponsor ${index + 1} logo...`);
//       const url = await uploadFileAndGetUrl(file, `sponsor-${index}`);
//       onArrayChange("sponsors", index, "logo", url);
//       setMessage("✅ Sponsor logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Sponsor logo upload failed.");
//     }
//   };

//   const handleOrganizerLogoFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading organizer logo...");
//       const url = await uploadFileAndGetUrl(file, "organizer");
//       onNestedChange("organizer", "logoUrl", url);
//       setMessage("✅ Organizer logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Organizer logo upload failed.");
//     }
//   };

//   const handleVenueLogoFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading venue logo...");
//       const url = await uploadFileAndGetUrl(file, "venue");
//       onNestedChange("venue", "logoUrl", url);
//       setMessage("✅ Venue logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Venue logo upload failed.");
//     }
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage("");

//     try {
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const res = await post(API.events.createEvent, form, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       setMessage("✅ Event created successfully!");
//       console.log("Created event:", res);
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Failed to create event.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <form
//       onSubmit={onSubmit}
//       className="max-w-4xl mx-auto p-6 bg-gray-100 rounded-lg shadow-lg space-y-6"
//     >
//       <h1 className="text-2xl font-bold text-gray-800">Create Event</h1>

//       {/* Basic Info */}
//       <Section title="Basic Info">
//         <Input
//           label="Event Name"
//           value={form.name}
//           onChange={(v) => onChange("name", v)}
//           required
//         />
//         <Select
//           label="Category"
//           value={form.category}
//           options={[
//             "Music",
//             "Theatre",
//             "Comedy",
//             "Dance",
//             "Sports",
//             "Exhibition",
//             "Festival",
//             "Conference",
//             "Workshop",
//             "Other",
//           ]}
//           onChange={(v) => onChange("category", v)}
//         />
//         <Textarea
//           label="Description"
//           value={form.description}
//           onChange={(v) => onChange("description", v)}
//           rows={4}
//         />
//         {/* <Input
//           label="Event Date"
//           type="datetime-local"
//           value={form.date}
//           onChange={(v) => onChange("date", v)}
//           required
//         /> */}

//         <Input
//           label="Event Date"
//           type="datetime-local"
//           value={form.date}
//           onChange={(v) => {
//             const picked = new Date(v);
//             if (picked < startOfTomorrow) {
//               // वैकल्पिक: user feedback
//               setMessage("❌ Event Date must be after today.");
//               return;
//             }
//             onChange("date", v);
//           }}
//           required
//           min={minEventDate}   // ⬅️ यहीं से आज और पुरानी तारीख select नहीं होगी
//         />

//       </Section>

//       {/* Venue */}
//       {/* <Section title="Venue">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {Object.keys(form.venue).map((k) => (
//             <Input
//               key={k}
//               label={k.charAt(0).toUpperCase() + k.slice(1)}
//               value={form.venue[k]}
//               onChange={(v) => onNestedChange("venue", k, v)}
//               type={["latitude", "longitude", "capacity"].includes(k) ? "number" : "text"}
//             />
//           ))}
//         </div>
//       </Section> */}
//       <Section title="Venue">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {Object.keys(form.venue).filter(k => k !== "logoUrl").map((k) => (
//             <Input
//               key={k}
//               label={k.charAt(0).toUpperCase() + k.slice(1)}
//               value={form.venue[k]}
//               onChange={(v) => onNestedChange("venue", k, v)}
//               type={["latitude", "longitude", "capacity"].includes(k) ? "number" : "text"}
//             />
//           ))}
//         </div>

//         {/* ✅ Venue Logo */}
//         <div className="mt-4">
//           <label className="block font-medium text-gray-700">Venue Logo</label>
//           <div className="flex flex-col md:flex-row gap-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//               placeholder="Paste venue logo URL (optional)"
//               value={form.venue.logoUrl}
//               onChange={(e) => onNestedChange("venue", "logoUrl", e.target.value)}
//             />
//             <div className="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center">
//               <input
//                 type="file"
//                 accept="image/*"
//                 className="hidden"
//                 id="venue-logo-upload"
//                 onChange={handleVenueLogoFile}
//               />
//               <label htmlFor="venue-logo-upload" className="cursor-pointer text-blue-500 hover:text-blue-700">
//                 {uploadProgress["venue"] ? (
//                   <FaSpinner className="animate-spin inline-block mr-2" />
//                 ) : (
//                   "Choose or drag logo"
//                 )}
//               </label>
//             </div>
//           </div>
//           {form.venue.logoUrl && (
//             <div className="mt-2 flex items-center gap-3">
//               <img src={form.venue.logoUrl} alt="Venue Logo" className="h-16 w-16 object-cover rounded" />
//               <p className="text-sm text-gray-600 break-all">{form.venue.logoUrl}</p>
//             </div>
//           )}
//         </div>
//       </Section>

//       {/* Ticket Categories */}
//       <Section title="Ticket Categories">
//         {form.ticketCategories.map((t, i) => (
//           <div
//             key={i}
//             className="border p-4 my-2 rounded-lg bg-gray-50 shadow-sm"
//           >
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <Input
//                 label="Type"
//                 value={t.type}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "type", v)}
//               />
//               <Input
//                 label="Price"
//                 type="number"
//                 value={t.price}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "price", v)}
//               />
//               <Input
//                 label="Currency"
//                 value={t.currency}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "currency", v)}
//               />
//               <Input
//                 label="Total Seats"
//                 type="number"
//                 value={t.totalSeats}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "totalSeats", v)}
//               />
//               <Input
//                 label="Available Seats"
//                 type="number"
//                 value={t.availableSeats}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "availableSeats", v)}
//               />
//             </div>
//             <div className="mt-4">
//               <label className="block font-medium text-gray-700">Perks</label>
//               {t.perks.map((perk, j) => (
//                 <div key={j} className="flex items-center gap-2 mb-2">
//                   <input
//                     className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//                     value={perk}
//                     onChange={(e) => {
//                       const updated = [...t.perks];
//                       updated[j] = e.target.value;
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}
//                     placeholder="Add a perk..."
//                   />
//                   <button
//                     type="button"
//                     className="text-red-500 hover:text-red-700"
//                     onClick={() => {
//                       const updated = t.perks.filter((_, idx) => idx !== j);
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}
//                   >
//                     <FaTrash />
//                   </button>
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//                 onClick={() => onArrayChange("ticketCategories", i, "perks", [...t.perks, ""])}
//               >
//                 <FaPlus /> Add Perk
//               </button>
//             </div>
//             <button
//               type="button"
//               className="text-red-500 hover:text-red-700 mt-2 flex items-center gap-1"
//               onClick={() => removeArrayItem("ticketCategories", i)}
//             >
//               <FaTrash /> Remove Ticket
//             </button>
//           </div>
//         ))}
//         <button
//           type="button"
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//           onClick={() =>
//             addArrayItem("ticketCategories", {
//               type: "",
//               price: "",
//               currency: "INR",
//               totalSeats: "",
//               availableSeats: "",
//               perks: [""],
//             })
//           }
//         >
//           <FaPlus /> Add Ticket
//         </button>
//       </Section>

//       {/* Showtimes */}
//       <Section title="Showtimes">
//         {form.showtimes.map((s, i) => (
//           <div
//             key={i}
//             className="border p-4 my-2 rounded-lg bg-gray-50 shadow-sm"
//           >
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <Input
//                 label="Start Time"
//                 type="datetime-local"
//                 value={s.startTime}
//                 onChange={(v) => onArrayChange("showtimes", i, "startTime", v)}
//               />
//               <Input
//                 label="End Time"
//                 type="datetime-local"
//                 value={s.endTime}
//                 onChange={(v) => onArrayChange("showtimes", i, "endTime", v)}
//               />
//               <Input
//                 label="Available Seats"
//                 type="number"
//                 value={s.availableSeats}
//                 onChange={(v) => onArrayChange("showtimes", i, "availableSeats", v)}
//               />
//               <Input
//                 label="Ticket Price"
//                 type="number"
//                 value={s.ticketPrice}
//                 onChange={(v) => onArrayChange("showtimes", i, "ticketPrice", v)}
//               />
//             </div>
//             <button
//               type="button"
//               className="text-red-500 hover:text-red-700 mt-2 flex items-center gap-1"
//               onClick={() => removeArrayItem("showtimes", i)}
//             >
//               <FaTrash /> Remove Showtime
//             </button>
//           </div>
//         ))}
//         <button
//           type="button"
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//           onClick={() =>
//             addArrayItem("showtimes", {
//               startTime: "",
//               endTime: "",
//               availableSeats: "",
//               ticketPrice: "",
//             })
//           }
//         >
//           <FaPlus /> Add Showtime
//         </button>
//       </Section>

//       {/* Images */}
//       <Section title="Images">
//         <div>
//           <label className="block font-medium text-gray-700">Poster Image</label>
//           <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
//             <input
//               type="file"
//               accept="image/*"
//               className="hidden"
//               id="poster-upload"
//               onChange={handlePosterFile}
//             />
//             <label
//               htmlFor="poster-upload"
//               className="cursor-pointer text-blue-500 hover:text-blue-700"
//             >
//               {uploadProgress["poster"] ? (
//                 <FaSpinner className="animate-spin inline-block mr-2" />
//               ) : (
//                 "Choose or drag a poster image"
//               )}
//             </label>
//           </div>
//           {form.imageUrl && (
//             <div className="mt-2">
//               <img
//                 src={form.imageUrl}
//                 alt="Poster Preview"
//                 className="h-24 w-24 object-cover rounded"
//               />
//               <p className="text-sm text-gray-600 break-all mt-1">{form.imageUrl}</p>
//             </div>
//           )}
//         </div>

//         <label className="block font-medium text-gray-700 mt-4">Landscape Images</label>
//         {form.landsacpImage.map((img, i) => (
//           <div key={i} className="flex flex-col md:flex-row gap-2 mb-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//               placeholder="Paste image URL (optional)"
//               value={img}
//               onChange={(e) => {
//                 const imgs = [...form.landsacpImage];
//                 imgs[i] = e.target.value;
//                 onChange("landsacpImage", imgs);
//               }}
//             />
//             <div className="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center">
//               <input
//                 type="file"
//                 accept="image/*"
//                 className="hidden"
//                 id={`landscape-upload-${i}`}
//                 onChange={(e) => handleLandscapeFile(e, i)}
//               />
//               <label
//                 htmlFor={`landscape-upload-${i}`}
//                 className="cursor-pointer text-blue-500 hover:text-blue-700"
//               >
//                 {uploadProgress[`landscape-${i}`] ? (
//                   <FaSpinner className="animate-spin inline-block mr-2" />
//                 ) : (
//                   "Choose or drag image"
//                 )}
//               </label>
//             </div>
//             <button
//               type="button"
//               className="text-red-500 hover:text-red-700"
//               onClick={() => removeArrayItem("landsacpImage", i)}
//             >
//               <FaTrash />
//             </button>
//             {img && (
//               <img
//                 src={img}
//                 alt={`Landscape ${i + 1}`}
//                 className="h-16 w-16 object-cover rounded mt-2"
//               />
//             )}
//           </div>
//         ))}
//         <button
//           type="button"
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//           onClick={() => onChange("landsacpImage", [...form.landsacpImage, ""])}
//         >
//           <FaPlus /> Add Landscape Image
//         </button>
//       </Section>

//       {/* Organizer */}
//       <Section title="Organizer">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {Object.keys(form.organizer)
//             .filter((k) => k !== "logoUrl")
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={k.charAt(0).toUpperCase() + k.slice(1)}
//                 value={form.organizer[k]}
//                 onChange={(v) => onNestedChange("organizer", k, v)}
//               />
//             ))}
//         </div>
//         <div className="mt-4">
//           <label className="block font-medium text-gray-700">Organizer Logo</label>
//           <div className="flex flex-col md:flex-row gap-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//               placeholder="Paste logo URL (optional)"
//               value={form.organizer.logoUrl}
//               onChange={(e) => onNestedChange("organizer", "logoUrl", e.target.value)}
//             />
//             <div className="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center">
//               <input
//                 type="file"
//                 accept="image/*"
//                 className="hidden"
//                 id="organizer-logo-upload"
//                 onChange={handleOrganizerLogoFile}
//               />
//               <label
//                 htmlFor="organizer-logo-upload"
//                 className="cursor-pointer text-blue-500 hover:text-blue-700"
//               >
//                 {uploadProgress["organizer"] ? (
//                   <FaSpinner className="animate-spin inline-block mr-2" />
//                 ) : (
//                   "Choose or drag logo"
//                 )}
//               </label>
//             </div>
//           </div>
//           {form.organizer.logoUrl && (
//             <div className="mt-2 flex items-center gap-3">
//               <img
//                 src={form.organizer.logoUrl}
//                 alt="Organizer Logo"
//                 className="h-16 w-16 object-cover rounded"
//               />
//               <p className="text-sm text-gray-600 break-all">{form.organizer.logoUrl}</p>
//             </div>
//           )}
//         </div>
//       </Section>

//       {/* Sponsors */}
//       <Section title="Sponsors">
//         {form.sponsors.map((s, i) => (
//           <div
//             key={i}
//             className="border p-4 my-2 rounded-lg bg-gray-50 shadow-sm"
//           >
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <Input
//                 label="Name"
//                 value={s.name}
//                 onChange={(v) => onArrayChange("sponsors", i, "name", v)}
//               />
//               <Select
//                 label="Type"
//                 value={s.type}
//                 options={["Title Sponsor",
//                   "Presenting Sponsor",
//                   "Powered By Sponsor",
//                   "Associate Sponsor",
//                   "Official Partner",
//                   "Official Beverage Partner",
//                   "Official Food Partner",
//                   "Official Travel Partner",
//                   "Official Airline Partner",
//                   "Official Transport Partner",
//                   "Official Hotel Partner",
//                   "Official Hospitality Partner",
//                   "Official Bank Partner",
//                   "Official Insurance Partner",
//                   "Official Payment Partner",
//                   "Official Apparel Partner",
//                   "Official Footwear Partner",
//                   "Official Merchandise Partner",
//                   "Official Electronics Partner",
//                   "Official Technology Partner",
//                   "Official Streaming Partner",
//                   "Official Ticketing Partner",
//                   "Official Education Partner",
//                   "Official Telecom Partner",
//                   "Venue Partner",
//                   "Logistics Partner",
//                   "Stage & Equipment Partner",
//                   "Printing Partner",
//                   "Security Partner",
//                   "Decoration Partner",
//                   "Photography Partner",
//                   "Medical Partner",
//                   "Gifts Partner",
//                   "Print Media Partner",
//                   "TV Media Partner",
//                   "Radio Partner",
//                   "Digital Media Partner",
//                   "Outdoor Media Partner",
//                   "Social Media Partner",
//                   "Accommodation Partner",
//                   "Catering Partner",
//                   "Food & Beverage Partner",
//                   "Lounge Partner",
//                   "App Partner",
//                   "WiFi Partner",
//                   "Virtual Event Partner",
//                   "AR/VR Partner",
//                   "Gaming Partner",
//                   "NGO Partner",
//                   "Environmental Partner",
//                   "Government Partner",
//                   "Cultural Partner"]}
//                 onChange={(v) => onArrayChange("sponsors", i, "type", v)}
//               />
//             </div>
//             <Textarea
//               label="Description"
//               value={s.description}
//               onChange={(v) => onArrayChange("sponsors", i, "description", v)}
//               rows={3}
//             />
//             <div className="mt-4">
//               <label className="block font-medium text-gray-700">Logo</label>
//               <div className="flex flex-col md:flex-row gap-2">
//                 <input
//                   className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//                   placeholder="Paste logo URL (optional)"
//                   value={s.logo}
//                   onChange={(e) => onArrayChange("sponsors", i, "logo", e.target.value)}
//                 />
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center">
//                   <input
//                     type="file"
//                     accept="image/*"
//                     className="hidden"
//                     id={`sponsor-logo-upload-${i}`}
//                     onChange={(e) => handleSponsorLogoFile(e, i)}
//                   />
//                   <label
//                     htmlFor={`sponsor-logo-upload-${i}`}
//                     className="cursor-pointer text-blue-500 hover:text-blue-700"
//                   >
//                     {uploadProgress[`sponsor-${i}`] ? (
//                       <FaSpinner className="animate-spin inline-block mr-2" />
//                     ) : (
//                       "Choose or drag logo"
//                     )}
//                   </label>
//                 </div>
//               </div>
//               {s.logo && (
//                 <div className="mt-2 flex items-center gap-3">
//                   <img
//                     src={s.logo}
//                     alt={`Sponsor ${i + 1} logo`}
//                     className="h-16 w-16 object-cover rounded"
//                   />
//                   <p className="text-sm text-gray-600 break-all">{s.logo}</p>
//                 </div>
//               )}
//             </div>
//             <button
//               type="button"
//               className="text-red-500 hover:text-red-700 mt-2 flex items-center gap-1"
//               onClick={() => removeArrayItem("sponsors", i)}
//             >
//               <FaTrash /> Remove Sponsor
//             </button>
//           </div>
//         ))}
//         <button
//           type="button"
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//           onClick={() =>
//             addArrayItem("sponsors", {
//               name: "",
//               logo: "",
//               description: "",
//               type: "Title Sponsor",
//             })
//           }
//         >
//           <FaPlus /> Add Sponsor
//         </button>
//       </Section>

//       {/* Terms & Conditions */}
//       <Section title="Terms & Conditions">
//         {form.termsAndConditions.map((t, i) => (
//           <div key={i} className="flex items-center gap-2 mb-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//               placeholder="Write a point..."
//               value={t.point}
//               onChange={(e) => onArrayChange("termsAndConditions", i, "point", e.target.value)}
//             />
//             <button
//               type="button"
//               className="text-red-500 hover:text-red-700"
//               onClick={() => removeArrayItem("termsAndConditions", i)}
//             >
//               <FaTrash />
//             </button>
//           </div>
//         ))}
//         <button
//           type="button"
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//           onClick={() => addArrayItem("termsAndConditions", { point: "" })}
//         >
//           <FaPlus /> Add Point
//         </button>
//       </Section>

//       {/* Other Details */}
//       <Section title="Other Details">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <Select
//             label="Status"
//             value={form.status}
//             options={["Upcoming", "Live"]}
//             onChange={(v) => onChange("status", v)}
//           />
//           <Input
//             label="Remark"
//             value={form.remark}
//             onChange={(v) => onChange("remark", v)}
//           />
//           <Input
//             label="Age Restriction"
//             type="number"
//             value={form.ageRestriction}
//             onChange={(v) => onChange("ageRestriction", v)}
//           />
//           <Input
//             label="Language"
//             value={form.language}
//             onChange={(v) => onChange("language", v)}
//           />
//           <Input
//             label="Duration (minutes)"
//             type="number"
//             value={form.duration}
//             onChange={(v) => onChange("duration", v)}
//           />
//         </div>
//         <div className="flex items-center gap-4 mt-4">
//           <label className="flex items-center gap-2">
//             <input
//               type="checkbox"
//               checked={form.isVerified}
//               onChange={(e) => onChange("isVerified", e.target.checked)}
//               className="h-4 w-4 text-blue-600 focus:ring-blue-500"
//             />
//             Premium
//           </label>
//            <label className="flex items-center gap-2">
//             <input
//               type="checkbox"
//               checked={form.isBookingOpen}
//               onChange={(e) => onChange("isBookingOpen", e.target.checked)}
//               className="h-4 w-4 text-blue-600 focus:ring-blue-500"
//             />
//             Booking Open
//           </label>
//           <label className="flex items-center gap-2">
//             <input
//               type="checkbox"
//               checked={form.isActived}
//               onChange={(e) => onChange("isActived", e.target.checked)}
//               className="h-4 w-4 text-blue-600 focus:ring-blue-500"
//             />
//             Active
//           </label>
//         </div>
//       </Section>

//       {/* Submit Button and Message */}
//       <div className="flex items-center gap-3">
//         <button
//           type="submit"
//           className="bg-amber-400 hover:bg-amber-500 text-white px-6 py-2 rounded-lg flex items-center gap-2 disabled:opacity-50"
//           disabled={loading}
//         >
//           {loading ? (
//             <>
//               <FaSpinner className="animate-spin" /> Submitting...
//             </>
//           ) : (
//             "Submit"
//           )}
//         </button>
//         {message && (
//           <span className="text-sm flex items-center gap-2">
//             {message.includes("✅") ? (
//               <FaCheckCircle className="text-green-500" />
//             ) : (
//               <FaTimesCircle className="text-red-500" />
//             )}
//             {message}
//           </span>
//         )}
//       </div>
//     </form>
//   );
// }

// /* Reusable Components */
// const Section = ({ title, children }) => (
//   <div className="p-6 border rounded-lg bg-white shadow-sm">
//     <h2 className="text-lg font-semibold text-gray-800 mb-4">{title}</h2>
//     <div className="space-y-4">{children}</div>
//   </div>
// );

// const Input = ({ label, value, onChange, type = "text", required = false, placeholder }) => (
//   <div>
//     <label className="block font-medium text-gray-700">{label}</label>
//     <input
//       type={type}
//       className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       required={required}
//       placeholder={placeholder}
//       aria-label={label}
//     />
//   </div>
// );

// const Textarea = ({ label, value, onChange, rows = 4, placeholder }) => (
//   <div>
//     <label className="block font-medium text-gray-700">{label}</label>
//     <textarea
//       className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       rows={rows}
//       placeholder={placeholder}
//       aria-label={label}
//     />
//   </div>
// );

// const Select = ({ label, value, onChange, options }) => (
//   <div>
//     <label className="block font-medium text-gray-700">{label}</label>
//     <select
//       className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       aria-label={label}
//     >
//       {options.map((opt) => (
//         <option key={opt} value={opt}>
//           {opt}
//         </option>
//       ))}
//     </select>
//   </div>
// );

// // src/pages/admin/events/AdminEventForm.jsx
// import React, { useState } from "react";
// import { API } from "../../../config/api";
// import { post } from "../../../lib/http";
// import {
//   FaPlus,
//   FaTrash,
//   FaSpinner,
//   FaCheckCircle,
//   FaTimesCircle,
//   FaUpload,
//   FaImage,
// } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import RichText from "./RichText";

// /* --------------------------- helpers --------------------------- */
// const toDTLocal = (d) => {
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
//     d.getHours()
//   )}:${pad(d.getMinutes())}`;
// };
// const cn = (...a) => a.filter(Boolean).join(" ");
// const ACCEPTED_IMG = ["image/jpeg", "image/png", "image/webp"];
// const MAX_IMG_MB = 5;

// /* ========================= component ========================== */
// export default function AdminEventForm() {

//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     name: "",
//     category: "Music",
//     description: "",
//     venue: {
//       name: "",
//       address: "",
//       city: "",
//       state: "",
//       country: "",
//       pincode: "",
//       latitude: "",
//       longitude: "",
//       capacity: "",
//       logoUrl: "",
//     },
//     date: "",
//     eventEndDate: "",
//     ticketCategories: [
//       { type: "", price: "", currency: "INR", totalSeats: "", availableSeats: "", perks: [""] },
//     ],
//     showtimes: [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
//     imageUrl: "",
//     landsacpImage: [""],
//     status: "Upcoming",
//     organizer: { name: "", contactEmail: "", contactPhone: "", website: "", logoUrl: "" },
//     termsAndConditions: [{ point: "" }],
//     ratings: { averageRating: 0, totalReviews: 0 },
//     isVerified: false,
//     isBookingOpen: true,
//     isActived: true,
//     remark: "",
//     tags: [""],
//     sponsors: [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
//     ageRestriction: "",
//     language: "",
//     duration: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState({});

//   // date min: tomorrow 00:00
//   const now = new Date();
//   const startOfTomorrow = new Date(
//     now.getFullYear(),
//     now.getMonth(),
//     now.getDate() + 1,
//     0,
//     0,
//     0
//   );
//   const minEventDate = toDTLocal(startOfTomorrow);

//   /* --------------------------- setters --------------------------- */
//   const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));
//   const onNestedChange = (parent, key, value) =>
//     setForm((f) => ({ ...f, [parent]: { ...f[parent], [key]: value } }));

//   const onArrayChange = (arrKey, index, key, value) => {
//     const updated = [...form[arrKey]];
//     updated[index][key] = value;
//     setForm((f) => ({ ...f, [arrKey]: updated }));
//   };
//   const addArrayItem = (arrKey, newItem) =>
//     setForm((f) => ({ ...f, [arrKey]: [...f[arrKey], newItem] }));
//   const removeArrayItem = (arrKey, index) =>
//     setForm((f) => ({ ...f, [arrKey]: f[arrKey].filter((_, i) => i !== index) }));

//   /* ------------------------- upload utils ------------------------ */
//   const uploadFileAndGetUrl = async (file, progressKey = "file") => {
//     if (!file) return "";
//     if (!ACCEPTED_IMG.includes(file.type)) {
//       toast.warn("Please upload JPG/PNG/WEBP image.");
//       return "";
//     }
//     if (file.size > MAX_IMG_MB * 1024 * 1024) {
//       toast.warn(`Image must be under ${MAX_IMG_MB} MB.`);
//       return "";
//     }

//     const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//     const fd = new FormData();
//     fd.append("file", file);

//     try {
//       setUploadProgress((p) => ({ ...p, [progressKey]: 1 }));
//       const resp = await post(API.events.fileUploader, fd, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       const url =
//         resp?.url ||
//         resp?.resp?.url ||
//         resp?.fileUrl ||
//         resp?.location ||
//         resp?.path ||
//         resp?.secure_url ||
//         "";

//       if (!url) throw new Error("Upload success but no URL returned.");
//       toast.success("Image uploaded ✅");
//       return url;
//     } catch (e) {
//       console.error(e);
//       toast.error("Upload failed ❌");
//       return "";
//     } finally {
//       setUploadProgress((p) => ({ ...p, [progressKey]: 0 }));
//     }
//   };

//   const handlePosterFile = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, "poster");
//     if (url) onChange("imageUrl", url);
//   };

//   const handleLandscapeFile = async (e, index) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, `landscape-${index}`);
//     if (url) {
//       const imgs = [...form.landsacpImage];
//       imgs[index] = url;
//       onChange("landsacpImage", imgs);
//     }
//   };

//   const handleSponsorLogoFile = async (e, index) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, `sponsor-${index}`);
//     if (url) onArrayChange("sponsors", index, "logo", url);
//   };

//   const handleOrganizerLogoFile = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, "organizer");
//     if (url) onNestedChange("organizer", "logoUrl", url);
//   };

//   const handleVenueLogoFile = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, "venue");
//     if (url) onNestedChange("venue", "logoUrl", url);
//   };

//   /* --------------------------- submit ---------------------------- */
//   const validate = () => {
//     if (!form.name.trim()) return toast.warn("Please enter event name.");
//     if (!form.date) return toast.warn("Please select event date.");
//     if (new Date(form.date) < startOfTomorrow)
//       return toast.warn("Event date must be after today.");
//     if (!form.venue.city.trim()) return toast.warn("Please enter venue city.");
//     if (!form.ticketCategories?.length) return toast.warn("Add at least one ticket category.");
//     return true;
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       setLoading(true);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const res = await post(API.events.createEvent, form, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: token ? `Bearer ${token}` : undefined,
//         },
//       });
//       console.log("Created event:", res);
//       setTimeout(() => navigate("/admin/events"), 1200);
//       toast.success("Event created successfully ✅");
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to create event ❌");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ----------------------------- UI ----------------------------- */
//   return (
//     <form
//       onSubmit={onSubmit}
//       className="mx-auto max-w-6xl p-6 md:p-8 space-y-6 rounded-2xl border border-amber-100 bg-white/90 backdrop-blur shadow-sm"
//     >
//       {/* Header */}
//       <div className="flex items-center justify-between">
//         <div>
//           <h1 className="text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight">
//             Create Event
//           </h1>
//           <p className="text-sm text-slate-600">
//             Add all details, images, tickets and partners—then publish.
//           </p>
//         </div>
//         <span
//           className={cn(
//             "rounded-full px-3 py-1 text-xs font-semibold",
//             form.isActived ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-700"
//           )}
//         >
//           {form.isActived ? "Active" : "Inactive"}
//         </span>
//       </div>

//       {/* Basic Info */}
//       <Section title="Basic Info" hint="General details and primary schedule.">
//         <div className={AD.formGrid2}>
//           <Input
//             label="Event Name"
//             value={form.name}
//             onChange={(v) => onChange("name", v)}
//             required
//             placeholder="e.g. Sunburn Arena"
//           />
//           <Select
//             label="Category"
//             value={form.category}
//             onChange={(v) => onChange("category", v)}
//             options={[
//               "Music",
//               "Theatre",
//               "Comedy",
//               "Dance",
//               "Sports",
//               "Exhibition",
//               "Festival",
//               "Conference",
//               "Workshop",
//               "Other",
//             ]}
//           />
//         </div>

//          <RichText
//           label="Description"
//           value={form.description}
//           onChange={(html) => onChange("description", html)}
//           placeholder="What’s special about this event? Add details, headliners, schedule, FAQs, etc."
//           minHeight={260}
//         />

//         <div className={AD.formGrid2}>
//           <Input
//             label="Event Date"
//             type="datetime-local"
//             value={form.date}
//             onChange={(v) => {
//               const picked = new Date(v);
//               if (picked < startOfTomorrow) {
//                 toast.warn("Event date must be after today.");
//                 return;
//               }
//               onChange("date", v);
//             }}
//             required
//             min={minEventDate}
//           />
//           <Input
//             label="Event End Date (optional)"
//             type="datetime-local"
//             value={form.eventEndDate}
//             onChange={(v) => onChange("eventEndDate", v)}
//             min={form.date || minEventDate}
//           />
//         </div>
//       </Section>

//       {/* Venue */}
//       <Section title="Venue" hint="Venue details and maps metadata.">
//         <div className={AD.formGrid2}>
//           {Object.keys(form.venue)
//             .filter((k) => k !== "logoUrl")
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={capitalize(k)}
//                 value={form.venue[k]}
//                 onChange={(v) => onNestedChange("venue", k, v)}
//                 type={["latitude", "longitude", "capacity"].includes(k) ? "number" : "text"}
//               />
//             ))}
//         </div>

//         <Uploader
//           label="Venue Logo"
//           progress={uploadProgress["venue"] > 0}
//           onFile={handleVenueLogoFile}
//           previewUrl={form.venue.logoUrl}
//           onClear={() => onNestedChange("venue", "logoUrl", "")}
//         />
//       </Section>

//       {/* Tickets */}
//       <Section title="Ticket Categories" hint="Types, prices and perks.">
//         {form.ticketCategories.map((t, i) => (
//           <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
//             <div className={AD.formGrid2}>
//               <Input
//                 label="Type"
//                 value={t.type}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "type", v)}
//                 placeholder="e.g. VIP / Gold / GA"
//               />
//               <Input
//                 label="Price (₹)"
//                 type="number"
//                 value={t.price}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "price", v)}
//               />
//               <Input
//                 label="Currency"
//                 value={t.currency}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "currency", v)}
//               />
//               <Input
//                 label="Total Seats"
//                 type="number"
//                 value={t.totalSeats}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "totalSeats", v)}
//               />
//               <Input
//                 label="Available Seats"
//                 type="number"
//                 value={t.availableSeats}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "availableSeats", v)}
//               />
//             </div>

//             <div className="mt-4">
//               <Label>Perks</Label>
//               {t.perks.map((perk, j) => (
//                 <div key={j} className="flex items-center gap-2 mb-2">
//                   <input
//                     className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
//                     value={perk}
//                     onChange={(e) => {
//                       const updated = [...t.perks];
//                       updated[j] = e.target.value;
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}
//                     placeholder="Add a perk…"
//                   />
//                   <IconButton
//                     label="Remove Perk"
//                     onClick={() => {
//                       const updated = t.perks.filter((_, idx) => idx !== j);
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}
//                   >
//                     <FaTrash />
//                   </IconButton>
//                 </div>
//               ))}
//               <GhostButton onClick={() => onArrayChange("ticketCategories", i, "perks", [...t.perks, ""])}>
//                 <FaPlus /> Add Perk
//               </GhostButton>
//             </div>

//             <div className="mt-3">
//               <DangerButton onClick={() => removeArrayItem("ticketCategories", i)}>
//                 <FaTrash /> Remove Ticket
//               </DangerButton>
//             </div>
//           </div>
//         ))}

//         <PrimaryGhost onClick={() =>
//             addArrayItem("ticketCategories", {
//               type: "",
//               price: "",
//               currency: "INR",
//               totalSeats: "",
//               availableSeats: "",
//               perks: [""],
//             })
//           }>
//           <FaPlus /> Add Ticket
//         </PrimaryGhost>
//       </Section>

//       {/* Showtimes */}
//       <Section title="Showtimes" hint="Multiple slots for multi-show events.">
//         {form.showtimes.map((s, i) => (
//           <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
//             <div className={AD.formGrid2}>
//               <Input
//                 label="Start Time"
//                 type="datetime-local"
//                 value={s.startTime}
//                 onChange={(v) => onArrayChange("showtimes", i, "startTime", v)}
//               />
//               <Input
//                 label="End Time"
//                 type="datetime-local"
//                 value={s.endTime}
//                 onChange={(v) => onArrayChange("showtimes", i, "endTime", v)}
//               />
//               <Input
//                 label="Available Seats"
//                 type="number"
//                 value={s.availableSeats}
//                 onChange={(v) => onArrayChange("showtimes", i, "availableSeats", v)}
//               />
//               <Input
//                 label="Ticket Price (₹)"
//                 type="number"
//                 value={s.ticketPrice}
//                 onChange={(v) => onArrayChange("showtimes", i, "ticketPrice", v)}
//               />
//             </div>
//             <div className="mt-3">
//               <DangerButton onClick={() => removeArrayItem("showtimes", i)}>
//                 <FaTrash /> Remove Showtime
//               </DangerButton>
//             </div>
//           </div>
//         ))}

//         <PrimaryGhost
//           onClick={() =>
//             addArrayItem("showtimes", {
//               startTime: "",
//               endTime: "",
//               availableSeats: "",
//               ticketPrice: "",
//             })
//           }
//         >
//           <FaPlus /> Add Showtime
//         </PrimaryGhost>
//       </Section>

//       {/* Images */}
//       <Section title="Images" hint="Poster and landscape gallery.">
//         <Uploader
//           label="Poster Image"
//           progress={uploadProgress["poster"] > 0}
//           onFile={handlePosterFile}
//           previewUrl={form.imageUrl}
//           onClear={() => onChange("imageUrl", "")}
//         />

//         <div className="mt-4 space-y-2">
//           <Label>Landscape Images</Label>
//           {form.landsacpImage.map((img, i) => (
//             <div key={i} className="flex flex-col md:flex-row items-start md:items-center gap-3">
//               <input
//                 className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
//                 placeholder="Paste image URL (optional)"
//                 value={img}
//                 onChange={(e) => {
//                   const imgs = [...form.landsacpImage];
//                   imgs[i] = e.target.value;
//                   onChange("landsacpImage", imgs);
//                 }}
//               />
//               <div>
//                 <input
//                   id={`landscape-upload-${i}`}
//                   type="file"
//                   accept={ACCEPTED_IMG.join(",")}
//                   className="hidden"
//                   onChange={(e) => handleLandscapeFile(e, i)}
//                 />
//                 <label
//                   htmlFor={`landscape-upload-${i}`}
//                   className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-slate-50 cursor-pointer"
//                 >
//                   <FaUpload /> Upload
//                 </label>
//               </div>
//               <IconButton
//                 label="Remove Image"
//                 onClick={() => removeArrayItem("landsacpImage", i)}
//               >
//                 <FaTrash />
//               </IconButton>

//               {img ? (
//                 <img src={img} alt={`Landscape ${i + 1}`} className="h-16 w-24 object-cover rounded border" />
//               ) : (
//                 <div className="h-16 w-24 grid place-items-center rounded border text-slate-400">
//                   <FaImage />
//                 </div>
//               )}
//             </div>
//           ))}
//           <PrimaryGhost onClick={() => onChange("landsacpImage", [...form.landsacpImage, ""])}>
//             <FaPlus /> Add Landscape Image
//           </PrimaryGhost>
//         </div>
//       </Section>

//       {/* Organizer */}
//       <Section title="Organizer" hint="Organizer details & branding.">
//         <div className={AD.formGrid2}>
//           {Object.keys(form.organizer)
//             .filter((k) => k !== "logoUrl")
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={capitalize(k)}
//                 value={form.organizer[k]}
//                 onChange={(v) => onNestedChange("organizer", k, v)}
//               />
//             ))}
//         </div>
//         <Uploader
//           label="Organizer Logo"
//           progress={uploadProgress["organizer"] > 0}
//           onFile={handleOrganizerLogoFile}
//           previewUrl={form.organizer.logoUrl}
//           onClear={() => onNestedChange("organizer", "logoUrl", "")}
//         />
//       </Section>

//       {/* Sponsors */}
//       <Section title="Sponsors" hint="Add partner logos and types.">
//         {form.sponsors.map((s, i) => (
//           <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
//             <div className={AD.formGrid2}>
//               <Input
//                 label="Name"
//                 value={s.name}
//                 onChange={(v) => onArrayChange("sponsors", i, "name", v)}
//               />
//               <Select
//                 label="Type"
//                 value={s.type}
//                 onChange={(v) => onArrayChange("sponsors", i, "type", v)}
//                 options={[
//                   "Title Sponsor",
//                   "Presenting Sponsor",
//                   "Powered By Sponsor",
//                   "Associate Sponsor",
//                   "Official Partner",
//                   "Official Beverage Partner",
//                   "Official Food Partner",
//                   "Official Travel Partner",
//                   "Official Airline Partner",
//                   "Official Transport Partner",
//                   "Official Hotel Partner",
//                   "Official Hospitality Partner",
//                   "Official Bank Partner",
//                   "Official Insurance Partner",
//                   "Official Payment Partner",
//                   "Official Apparel Partner",
//                   "Official Footwear Partner",
//                   "Official Merchandise Partner",
//                   "Official Electronics Partner",
//                   "Official Technology Partner",
//                   "Official Streaming Partner",
//                   "Official Ticketing Partner",
//                   "Official Education Partner",
//                   "Official Telecom Partner",
//                   "Venue Partner",
//                   "Logistics Partner",
//                   "Stage & Equipment Partner",
//                   "Printing Partner",
//                   "Security Partner",
//                   "Decoration Partner",
//                   "Photography Partner",
//                   "Medical Partner",
//                   "Gifts Partner",
//                   "Print Media Partner",
//                   "TV Media Partner",
//                   "Radio Partner",
//                   "Digital Media Partner",
//                   "Outdoor Media Partner",
//                   "Social Media Partner",
//                   "Accommodation Partner",
//                   "Catering Partner",
//                   "Food & Beverage Partner",
//                   "Lounge Partner",
//                   "App Partner",
//                   "WiFi Partner",
//                   "Virtual Event Partner",
//                   "AR/VR Partner",
//                   "Gaming Partner",
//                   "NGO Partner",
//                   "Environmental Partner",
//                   "Government Partner",
//                   "Cultural Partner",
//                 ]}
//               />
//             </div>
//             <Textarea
//               label="Description"
//               value={s.description}
//               onChange={(v) => onArrayChange("sponsors", i, "description", v)}
//               rows={3}
//             />
//             <Uploader
//               label="Logo"
//               progress={uploadProgress[`sponsor-${i}`] > 0}
//               onFile={(e) => handleSponsorLogoFile(e, i)}
//               previewUrl={s.logo}
//               onClear={() => onArrayChange("sponsors", i, "logo", "")}
//               inputId={`sponsor-logo-upload-${i}`}
//             />
//             <div className="mt-3">
//               <DangerButton onClick={() => removeArrayItem("sponsors", i)}>
//                 <FaTrash /> Remove Sponsor
//               </DangerButton>
//             </div>
//           </div>
//         ))}
//         <PrimaryGhost
//           onClick={() =>
//             addArrayItem("sponsors", {
//               name: "",
//               logo: "",
//               description: "",
//               type: "Title Sponsor",
//             })
//           }
//         >
//           <FaPlus /> Add Sponsor
//         </PrimaryGhost>
//       </Section>

//       {/* Terms & Conditions */}
//       <Section title="Terms & Conditions" hint="Displayed on the event page.">
//         {form.termsAndConditions.map((t, i) => (
//           <div key={i} className="flex items-center gap-2 mb-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
//               placeholder="Write a point…"
//               value={t.point}
//               onChange={(e) => onArrayChange("termsAndConditions", i, "point", e.target.value)}
//             />
//             <IconButton
//               label="Remove"
//               onClick={() => removeArrayItem("termsAndConditions", i)}
//             >
//               <FaTrash />
//             </IconButton>
//           </div>
//         ))}
//         <PrimaryGhost onClick={() => addArrayItem("termsAndConditions", { point: "" })}>
//           <FaPlus /> Add Point
//         </PrimaryGhost>
//       </Section>

//       {/* Other Details */}
//       <Section title="Other Details">
//         <div className={AD.formGrid2}>
//           <Select
//             label="Status"
//             value={form.status}
//             onChange={(v) => onChange("status", v)}
//             options={["Upcoming", "Live"]}
//           />
//           <Input label="Remark" value={form.remark} onChange={(v) => onChange("remark", v)} />
//           <Input
//             label="Age Restriction"
//             type="number"
//             value={form.ageRestriction}
//             onChange={(v) => onChange("ageRestriction", v)}
//           />
//           <Input label="Language" value={form.language} onChange={(v) => onChange("language", v)} />
//           <Input
//             label="Duration (minutes)"
//             type="number"
//             value={form.duration}
//             onChange={(v) => onChange("duration", v)}
//           />
//         </div>

//         {/* Toggles */}
//         <div className="mt-3 grid gap-3 sm:grid-cols-3">
//           <Toggle
//             label="Premium"
//             checked={form.isVerified}
//             onChange={(v) => onChange("isVerified", v)}
//           />
//           <Toggle
//             label="Booking Open"
//             checked={form.isBookingOpen}
//             onChange={(v) => onChange("isBookingOpen", v)}
//           />
//           <Toggle
//             label="Active"
//             checked={form.isActived}
//             onChange={(v) => onChange("isActived", v)}
//           />
//         </div>
//       </Section>

//       {/* Sticky footer actions */}
//       <div className="sticky bottom-3 z-10">
//         <div className="rounded-2xl border bg-white/90 backdrop-blur p-3 shadow-md flex items-center gap-3">
//           <button
//             type="submit"
//             className={cn(
//               "rounded-full bg-gradient-to-r from-yellow-400 to-yellow-500 px-6 py-2.5 text-sm font-semibold text-slate-900 hover:from-yellow-500 hover:to-yellow-600 transition-all",
//               loading && "opacity-60 cursor-wait"
//             )}
//             disabled={loading}
//           >
//             {loading ? (
//               <span className="inline-flex items-center gap-2">
//                 <FaSpinner className="animate-spin" /> Submitting…
//               </span>
//             ) : (
//               "Create Event"
//             )}
//           </button>

//           {loading ? (
//             <span className="text-sm text-slate-600 flex items-center gap-2">
//               <FaSpinner className="animate-spin" /> Please wait
//             </span>
//           ) : form.name && form.imageUrl ? (
//             <span className="text-sm text-emerald-600 flex items-center gap-2">
//               <FaCheckCircle /> Ready to publish
//             </span>
//           ) : (
//             <span className="text-sm text-slate-500 flex items-center gap-2">
//               <FaTimesCircle /> Add name & poster to proceed
//             </span>
//           )}
//         </div>
//       </div>
//     </form>
//   );
// }

// /* ========================= small bits ========================= */
// function Section({ title, hint, children }) {
//   return (
//     <div className="rounded-2xl border border-amber-100/70 bg-white/70 p-5 shadow-sm">
//       <div className="mb-3">
//         <h2 className="text-lg font-bold text-slate-900">{title}</h2>
//         {hint && <p className="text-xs text-slate-500">{hint}</p>}
//       </div>
//       <div className="space-y-4">{children}</div>
//     </div>
//   );
// }

// function Label({ children }) {
//   return <label className="block font-semibold text-slate-700">{children}</label>;
// }

// function Input({ label, value, onChange, type = "text", required = false, placeholder, min }) {
//   return (
//     <div>
//       <Label>{label}{required && <span className="text-rose-500"> *</span>}</Label>
//       <input
//         type={type}
//         className="mt-1 border w-full rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-300"
//         value={value}
//         min={min}
//         onChange={(e) => onChange(e.target.value)}
//         required={required}
//         placeholder={placeholder}
//         aria-label={label}
//       />
//     </div>
//   );
// }

// function Textarea({ label, value, onChange, rows = 4, placeholder }) {
//   return (
//     <div>
//       <Label>{label}</Label>
//       <textarea
//         className="mt-1 border w-full rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-300"
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         rows={rows}
//         placeholder={placeholder}
//         aria-label={label}
//       />
//     </div>
//   );
// }

// function Select({ label, value, onChange, options = [] }) {
//   return (
//     <div>
//       <Label>{label}</Label>
//       <div className="relative mt-1">
//         <select
//           className="w-full appearance-none rounded-xl border px-3 py-2.5 pr-9 focus:ring-2 focus:ring-amber-300"
//           value={value}
//           onChange={(e) => onChange(e.target.value)}
//           aria-label={label}
//         >
//           {options.map((opt) => (
//             <option key={opt} value={opt}>
//               {opt}
//             </option>
//           ))}
//         </select>
//         <svg
//           className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
//           width="16"
//           height="16"
//           viewBox="0 0 24 24"
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="1.8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         >
//           <path d="M6 9l6 6 6-6" />
//         </svg>
//       </div>
//     </div>
//   );
// }

// function Uploader({ label, progress, onFile, previewUrl, onClear, inputId }) {
//   const id = inputId || `uploader-${label.replace(/\s+/g, "-").toLowerCase()}`;
//   return (
//     <div>
//       <Label>{label}</Label>
//       <div className="mt-2 flex flex-col md:flex-row items-start md:items-center gap-3">
//         <input id={id} type="file" accept={ACCEPTED_IMG.join(",")} className="hidden" onChange={onFile} />
//         <label
//           htmlFor={id}
//           className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold hover:bg-slate-50 cursor-pointer"
//         >
//           {progress ? <FaSpinner className="animate-spin" /> : <FaUpload />}
//           {progress ? "Uploading…" : "Upload"}
//         </label>

//         {previewUrl ? (
//           <>
//             <img src={previewUrl} alt="preview" className="h-16 w-24 object-cover rounded border" />
//             <IconButton label="Remove" onClick={onClear}>
//               <FaTrash />
//             </IconButton>
//           </>
//         ) : (
//           <div className="h-16 w-24 grid place-items-center rounded border text-slate-400">
//             <FaImage />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// function Toggle({ label, checked, onChange }) {
//   return (
//     <div className="flex items-center justify-between rounded-xl border px-4 py-3">
//       <div className="text-sm font-semibold text-slate-800">{label}</div>
//       <label className="relative inline-flex items-center cursor-pointer">
//         <input
//           type="checkbox"
//           checked={checked}
//           onChange={(e) => onChange(e.target.checked)}
//           className="sr-only peer"
//         />
//         <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
//           <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
//         </div>
//       </label>
//     </div>
//   );
// }

// function IconButton({ children, onClick, label }) {
//   return (
//     <button
//       type="button"
//       title={label}
//       aria-label={label}
//       onClick={onClick}
//       className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-slate-50"
//     >
//       {children}
//     </button>
//   );
// }

// function DangerButton({ children, onClick }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="inline-flex items-center gap-2 rounded-full border border-rose-300 text-rose-600 px-3 py-2 text-sm font-semibold hover:bg-rose-50"
//     >
//       {children}
//     </button>
//   );
// }

// function PrimaryGhost({ children, onClick }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-amber-50"
//     >
//       {children}
//     </button>
//   );
// }

// function GhostButton({ children, onClick }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="inline-flex items-center gap-2 text-amber-700 hover:text-amber-900"
//     >
//       {children}
//     </button>
//   );
// }

// function capitalize(s = "") {
//   return s.charAt(0).toUpperCase() + s.slice(1);
// }


// src/pages/admin/events/AdminEventForm.jsx
// import React, { useState } from "react";
// import { API } from "../../../config/api";
// import { post } from "../../../lib/http";
// import {
//   FaPlus,
//   FaTrash,
//   FaSpinner,
//   FaCheckCircle,
//   FaTimesCircle,
//   FaUpload,
//   FaImage,
// } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import RichText from "./RichText";

// /* --------------------------- helpers --------------------------- */
// const toDTLocal = (d) => {
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
//     d.getHours()
//   )}:${pad(d.getMinutes())}`;
// };
// const cn = (...a) => a.filter(Boolean).join(" ");
// const ACCEPTED_IMG = ["image/jpeg", "image/png", "image/webp"];
// const MAX_IMG_MB = 5;

// /* ========================= component ========================== */
// export default function AdminEventForm() {
//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     name: "",
//     category: "Music",
//     description: "",
//     venue: {
//       name: "",
//       address: "",
//       city: "",
//       state: "",
//       country: "",
//       pincode: "",
//       latitude: "",
//       longitude: "",
//       capacity: "",
//       logoUrl: "",
//     },
//     date: "",
//     eventEndDate: "",
//     ticketCategories: [
//       {
//         type: "",
//         price: "",
//         currency: "INR",
//         totalSeats: "",
//         availableSeats: "",
//         perks: [""],
//         isTicketAvailable: true, // NEW
//       },
//     ],
//     showtimes: [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
//     imageUrl: "",
//     landsacpImage: [""],
//     status: "Upcoming",
//     organizer: { name: "", contactEmail: "", contactPhone: "", website: "", logoUrl: "" },
//     termsAndConditions: [{ point: "" }],
//     ratings: { averageRating: 0, totalReviews: 0 },
//     isVerified: false,
//     isBookingOpen: true,
//     isActived: true,
//     remark: "",
//     tags: [""],
//     sponsors: [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
//     ageRestriction: "",
//     language: "",
//     duration: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState({});

//   // date min: tomorrow 00:00
//   const now = new Date();
//   const startOfTomorrow = new Date(
//     now.getFullYear(),
//     now.getMonth(),
//     now.getDate() + 1,
//     0,
//     0,
//     0
//   );
//   const minEventDate = toDTLocal(startOfTomorrow);

//   /* --------------------------- setters --------------------------- */
//   const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));
//   const onNestedChange = (parent, key, value) =>
//     setForm((f) => ({ ...f, [parent]: { ...f[parent], [key]: value } }));

//   const onArrayChange = (arrKey, index, key, value) => {
//     const updated = [...form[arrKey]];
//     updated[index][key] = value;
//     setForm((f) => ({ ...f, [arrKey]: updated }));
//   };
//   const addArrayItem = (arrKey, newItem) =>
//     setForm((f) => ({ ...f, [arrKey]: [...f[arrKey], newItem] }));
//   const removeArrayItem = (arrKey, index) =>
//     setForm((f) => ({ ...f, [arrKey]: f[arrKey].filter((_, i) => i !== index) }));

//   /* ------------------------- upload utils ------------------------ */
//   const uploadFileAndGetUrl = async (file, progressKey = "file") => {
//     if (!file) return "";
//     if (!ACCEPTED_IMG.includes(file.type)) {
//       toast.warn("Please upload JPG/PNG/WEBP image.");
//       return "";
//     }
//     if (file.size > MAX_IMG_MB * 1024 * 1024) {
//       toast.warn(`Image must be under ${MAX_IMG_MB} MB.`);
//       return "";
//     }

//     const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//     const fd = new FormData();
//     fd.append("file", file);

//     try {
//       setUploadProgress((p) => ({ ...p, [progressKey]: 1 }));
//       const resp = await post(API.events.fileUploader, fd, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       const url =
//         resp?.url ||
//         resp?.resp?.url ||
//         resp?.fileUrl ||
//         resp?.location ||
//         resp?.path ||
//         resp?.secure_url ||
//         "";

//       if (!url) throw new Error("Upload success but no URL returned.");
//       toast.success("Image uploaded ✅");
//       return url;
//     } catch (e) {
//       console.error(e);
//       toast.error("Upload failed ❌");
//       return "";
//     } finally {
//       setUploadProgress((p) => ({ ...p, [progressKey]: 0 }));
//     }
//   };

//   const handlePosterFile = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, "poster");
//     if (url) onChange("imageUrl", url);
//   };

//   const handleLandscapeFile = async (e, index) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, `landscape-${index}`);
//     if (url) {
//       const imgs = [...form.landsacpImage];
//       imgs[index] = url;
//       onChange("landsacpImage", imgs);
//     }
//   };

//   const handleSponsorLogoFile = async (e, index) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, `sponsor-${index}`);
//     if (url) onArrayChange("sponsors", index, "logo", url);
//   };

//   const handleOrganizerLogoFile = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, "organizer");
//     if (url) onNestedChange("organizer", "logoUrl", url);
//   };

//   const handleVenueLogoFile = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, "venue");
//     if (url) onNestedChange("venue", "logoUrl", url);
//   };

//   /* --------------------------- submit ---------------------------- */
//   const validate = () => {
//     if (!form.name.trim()) return toast.warn("Please enter event name.");
//     if (!form.date) return toast.warn("Please select event date.");
//     if (new Date(form.date) < startOfTomorrow)
//       return toast.warn("Event date must be after today.");
//     if (!form.venue.city.trim()) return toast.warn("Please enter venue city.");
//     if (!form.ticketCategories?.length) return toast.warn("Add at least one ticket category.");

//     // NEW: at least one ticket type is available
//     const hasAnyAvailable = form.ticketCategories.some((t) => t.isTicketAvailable);
//     if (!hasAnyAvailable) return toast.warn("At least one ticket type must be available.");

//     return true;
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       setLoading(true);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const res = await post(API.events.createEvent, form, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: token ? `Bearer ${token}` : undefined,
//         },
//       });
//       console.log("Created event:", res);
//       setTimeout(() => navigate("/admin/events"), 1200);
//       toast.success("Event created successfully ✅");
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to create event ❌");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ----------------------------- UI ----------------------------- */
//   return (
//     <form
//       onSubmit={onSubmit}
//       className="mx-auto max-w-6xl p-6 md:p-8 space-y-6 rounded-2xl border border-amber-100 bg-white/90 backdrop-blur shadow-sm"
//     >
//       {/* Header */}
//       <div className="flex items-center justify-between">
//         <div>
//           <h1 className="text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight">
//             Create Event
//           </h1>
//           <p className="text-sm text-slate-600">
//             Add all details, images, tickets and partners—then publish.
//           </p>
//         </div>
//         <span
//           className={cn(
//             "rounded-full px-3 py-1 text-xs font-semibold",
//             form.isActived ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-700"
//           )}
//         >
//           {form.isActived ? "Active" : "Inactive"}
//         </span>
//       </div>

//       {/* Basic Info */}
//       <Section title="Basic Info" hint="General details and primary schedule.">
//         <div className={AD.formGrid2}>
//           <Input
//             label="Event Name"
//             value={form.name}
//             onChange={(v) => onChange("name", v)}
//             required
//             placeholder="e.g. Sunburn Arena"
//           />
//           <Select
//             label="Category"
//             value={form.category}
//             onChange={(v) => onChange("category", v)}
//             options={[
//               "Music",
//               "Theatre",
//               "Comedy",
//               "Dance",
//               "Sports",
//               "Exhibition",
//               "Festival",
//               "Conference",
//               "Workshop",
//               "Other",
//             ]}
//           />
//         </div>

//         {/* Rich text editor for description */}
//         <RichText
//           label="Description"
//           value={form.description}
//           onChange={(html) => onChange("description", html)}
//           placeholder="What’s special about this event? Add details, headliners, schedule, FAQs, etc."
//           minHeight={260}
//         />

//         <div className={AD.formGrid2}>
//           <Input
//             label="Event Date"
//             type="datetime-local"
//             value={form.date}
//             onChange={(v) => {
//               const picked = new Date(v);
//               if (picked < startOfTomorrow) {
//                 toast.warn("Event date must be after today.");
//                 return;
//               }
//               onChange("date", v);
//             }}
//             required
//             min={minEventDate}
//           />
//           <Input
//             label="Event End Date (optional)"
//             type="datetime-local"
//             value={form.eventEndDate}
//             onChange={(v) => onChange("eventEndDate", v)}
//             min={form.date || minEventDate}
//           />
//         </div>
//       </Section>

//       {/* Venue */}
//       <Section title="Venue" hint="Venue details and maps metadata.">
//         <div className={AD.formGrid2}>
//           {Object.keys(form.venue)
//             .filter((k) => k !== "logoUrl")
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={capitalize(k)}
//                 value={form.venue[k]}
//                 onChange={(v) => onNestedChange("venue", k, v)}
//                 type={["latitude", "longitude", "capacity"].includes(k) ? "number" : "text"}
//               />
//             ))}
//         </div>

//         <Uploader
//           label="Venue Logo"
//           progress={uploadProgress["venue"] > 0}
//           onFile={handleVenueLogoFile}
//           previewUrl={form.venue.logoUrl}
//           onClear={() => onNestedChange("venue", "logoUrl", "")}
//         />
//       </Section>

//       {/* Tickets */}
//       <Section title="Ticket Categories" hint="Types, prices and perks.">
//         {form.ticketCategories.map((t, i) => (
//           <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
//             <div className={AD.formGrid2}>
//               <Input
//                 label="Type"
//                 value={t.type}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "type", v)}
//                 placeholder="e.g. VIP / Gold / GA"
//               />
//               <Input
//                 label="Price (₹)"
//                 type="number"
//                 value={t.price}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "price", v)}
//                 disabled={!t.isTicketAvailable} // NEW
//               />
//               <Input
//                 label="Currency"
//                 value={t.currency}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "currency", v)}
//                 disabled={!t.isTicketAvailable} // NEW
//               />
//               <Input
//                 label="Total Seats"
//                 type="number"
//                 value={t.totalSeats}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "totalSeats", v)}
//                 disabled={!t.isTicketAvailable} // NEW
//               />
//               <Input
//                 label="Available Seats"
//                 type="number"
//                 value={t.availableSeats}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "availableSeats", v)}
//                 disabled={!t.isTicketAvailable} // NEW
//               />
//             </div>

//             {/* NEW: tickets available toggle */}
//             <div className="mt-3 grid sm:grid-cols-2 gap-3">
//               <Toggle
//                 label="Tickets Available"
//                 checked={!!t.isTicketAvailable}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "isTicketAvailable", v)}
//               />
//             </div>

//             <div className="mt-4">
//               <Label>Perks</Label>
//               {t.perks.map((perk, j) => (
//                 <div key={j} className="flex items-center gap-2 mb-2">
//                   <input
//                     className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
//                     value={perk}
//                     onChange={(e) => {
//                       const updated = [...t.perks];
//                       updated[j] = e.target.value;
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}
//                     placeholder="Add a perk…"
//                     disabled={!t.isTicketAvailable} // optional
//                   />
//                   <IconButton
//                     label="Remove Perk"
//                     onClick={() => {
//                       const updated = t.perks.filter((_, idx) => idx !== j);
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}
//                   >
//                     <FaTrash />
//                   </IconButton>
//                 </div>
//               ))}
//               <GhostButton
//                 onClick={() =>
//                   onArrayChange("ticketCategories", i, "perks", [...t.perks, ""])
//                 }
//               >
//                 <FaPlus /> Add Perk
//               </GhostButton>
//             </div>

//             <div className="mt-3">
//               <DangerButton onClick={() => removeArrayItem("ticketCategories", i)}>
//                 <FaTrash /> Remove Ticket
//               </DangerButton>
//             </div>
//           </div>
//         ))}

//         <PrimaryGhost
//           onClick={() =>
//             addArrayItem("ticketCategories", {
//               type: "",
//               price: "",
//               currency: "INR",
//               totalSeats: "",
//               availableSeats: "",
//               perks: [""],
//               isTicketAvailable: true, // NEW
//             })
//           }
//         >
//           <FaPlus /> Add Ticket
//         </PrimaryGhost>
//       </Section>

//       {/* Showtimes */}
//       <Section title="Showtimes" hint="Multiple slots for multi-show events.">
//         {form.showtimes.map((s, i) => (
//           <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
//             <div className={AD.formGrid2}>
//               <Input
//                 label="Start Time"
//                 type="datetime-local"
//                 value={s.startTime}
//                 onChange={(v) => onArrayChange("showtimes", i, "startTime", v)}
//               />
//               <Input
//                 label="End Time"
//                 type="datetime-local"
//                 value={s.endTime}
//                 onChange={(v) => onArrayChange("showtimes", i, "endTime", v)}
//               />
//               <Input
//                 label="Available Seats"
//                 type="number"
//                 value={s.availableSeats}
//                 onChange={(v) => onArrayChange("showtimes", i, "availableSeats", v)}
//               />
//               <Input
//                 label="Ticket Price (₹)"
//                 type="number"
//                 value={s.ticketPrice}
//                 onChange={(v) => onArrayChange("showtimes", i, "ticketPrice", v)}
//               />
//             </div>
//             <div className="mt-3">
//               <DangerButton onClick={() => removeArrayItem("showtimes", i)}>
//                 <FaTrash /> Remove Showtime
//               </DangerButton>
//             </div>
//           </div>
//         ))}

//         <PrimaryGhost
//           onClick={() =>
//             addArrayItem("showtimes", {
//               startTime: "",
//               endTime: "",
//               availableSeats: "",
//               ticketPrice: "",
//             })
//           }
//         >
//           <FaPlus /> Add Showtime
//         </PrimaryGhost>
//       </Section>

//       {/* Images */}
//       <Section title="Images" hint="Poster and landscape gallery.">
//         <Uploader
//           label="Poster Image"
//           progress={uploadProgress["poster"] > 0}
//           onFile={handlePosterFile}
//           previewUrl={form.imageUrl}
//           onClear={() => onChange("imageUrl", "")}
//         />

//         <div className="mt-4 space-y-2">
//           <Label>Landscape Images</Label>
//           {form.landsacpImage.map((img, i) => (
//             <div key={i} className="flex flex-col md:flex-row items-start md:items-center gap-3">
//               <input
//                 className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
//                 placeholder="Paste image URL (optional)"
//                 value={img}
//                 onChange={(e) => {
//                   const imgs = [...form.landsacpImage];
//                   imgs[i] = e.target.value;
//                   onChange("landsacpImage", imgs);
//                 }}
//               />
//               <div>
//                 <input
//                   id={`landscape-upload-${i}`}
//                   type="file"
//                   accept={ACCEPTED_IMG.join(",")}
//                   className="hidden"
//                   onChange={(e) => handleLandscapeFile(e, i)}
//                 />
//                 <label
//                   htmlFor={`landscape-upload-${i}`}
//                   className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-slate-50 cursor-pointer"
//                 >
//                   <FaUpload /> Upload
//                 </label>
//               </div>
//               <IconButton
//                 label="Remove Image"
//                 onClick={() => removeArrayItem("landsacpImage", i)}
//               >
//                 <FaTrash />
//               </IconButton>

//               {img ? (
//                 <img src={img} alt={`Landscape ${i + 1}`} className="h-16 w-24 object-cover rounded border" />
//               ) : (
//                 <div className="h-16 w-24 grid place-items-center rounded border text-slate-400">
//                   <FaImage />
//                 </div>
//               )}
//             </div>
//           ))}
//           <PrimaryGhost onClick={() => onChange("landsacpImage", [...form.landsacpImage, ""])}>
//             <FaPlus /> Add Landscape Image
//           </PrimaryGhost>
//         </div>
//       </Section>

//       {/* Organizer */}
//       <Section title="Organizer" hint="Organizer details & branding.">
//         <div className={AD.formGrid2}>
//           {Object.keys(form.organizer)
//             .filter((k) => k !== "logoUrl")
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={capitalize(k)}
//                 value={form.organizer[k]}
//                 onChange={(v) => onNestedChange("organizer", k, v)}
//               />
//             ))}
//         </div>
//         <Uploader
//           label="Organizer Logo"
//           progress={uploadProgress["organizer"] > 0}
//           onFile={handleOrganizerLogoFile}
//           previewUrl={form.organizer.logoUrl}
//           onClear={() => onNestedChange("organizer", "logoUrl", "")}
//         />
//       </Section>

//       {/* Sponsors */}
//       <Section title="Sponsors" hint="Add partner logos and types.">
//         {form.sponsors.map((s, i) => (
//           <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
//             <div className={AD.formGrid2}>
//               <Input
//                 label="Name"
//                 value={s.name}
//                 onChange={(v) => onArrayChange("sponsors", i, "name", v)}
//               />
//               <Select
//                 label="Type"
//                 value={s.type}
//                 onChange={(v) => onArrayChange("sponsors", i, "type", v)}
//                 options={[
//                   "Title Sponsor",
//                   "Presenting Sponsor",
//                   "Powered By Sponsor",
//                   "Associate Sponsor",
//                   "Official Partner",
//                   "Official Beverage Partner",
//                   "Official Food Partner",
//                   "Official Travel Partner",
//                   "Official Airline Partner",
//                   "Official Transport Partner",
//                   "Official Hotel Partner",
//                   "Official Hospitality Partner",
//                   "Official Bank Partner",
//                   "Official Insurance Partner",
//                   "Official Payment Partner",
//                   "Official Apparel Partner",
//                   "Official Footwear Partner",
//                   "Official Merchandise Partner",
//                   "Official Electronics Partner",
//                   "Official Technology Partner",
//                   "Official Streaming Partner",
//                   "Official Ticketing Partner",
//                   "Official Education Partner",
//                   "Official Telecom Partner",
//                   "Venue Partner",
//                   "Logistics Partner",
//                   "Stage & Equipment Partner",
//                   "Printing Partner",
//                   "Security Partner",
//                   "Decoration Partner",
//                   "Photography Partner",
//                   "Medical Partner",
//                   "Gifts Partner",
//                   "Print Media Partner",
//                   "TV Media Partner",
//                   "Radio Partner",
//                   "Digital Media Partner",
//                   "Outdoor Media Partner",
//                   "Social Media Partner",
//                   "Accommodation Partner",
//                   "Catering Partner",
//                   "Food & Beverage Partner",
//                   "Lounge Partner",
//                   "App Partner",
//                   "WiFi Partner",
//                   "Virtual Event Partner",
//                   "AR/VR Partner",
//                   "Gaming Partner",
//                   "NGO Partner",
//                   "Environmental Partner",
//                   "Government Partner",
//                   "Cultural Partner",
//                 ]}
//               />
//             </div>
//             <Textarea
//               label="Description"
//               value={s.description}
//               onChange={(v) => onArrayChange("sponsors", i, "description", v)}
//               rows={3}
//             />
//             <Uploader
//               label="Logo"
//               progress={uploadProgress[`sponsor-${i}`] > 0}
//               onFile={(e) => handleSponsorLogoFile(e, i)}
//               previewUrl={s.logo}
//               onClear={() => onArrayChange("sponsors", i, "logo", "")}
//               inputId={`sponsor-logo-upload-${i}`}
//             />
//             <div className="mt-3">
//               <DangerButton onClick={() => removeArrayItem("sponsors", i)}>
//                 <FaTrash /> Remove Sponsor
//               </DangerButton>
//             </div>
//           </div>
//         ))}
//         <PrimaryGhost
//           onClick={() =>
//             addArrayItem("sponsors", {
//               name: "",
//               logo: "",
//               description: "",
//               type: "Title Sponsor",
//             })
//           }
//         >
//           <FaPlus /> Add Sponsor
//         </PrimaryGhost>
//       </Section>

//       {/* Terms & Conditions */}
//       <Section title="Terms & Conditions" hint="Displayed on the event page.">
//         {form.termsAndConditions.map((t, i) => (
//           <div key={i} className="flex items-center gap-2 mb-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
//               placeholder="Write a point…"
//               value={t.point}
//               onChange={(e) => onArrayChange("termsAndConditions", i, "point", e.target.value)}
//             />
//             <IconButton label="Remove" onClick={() => removeArrayItem("termsAndConditions", i)}>
//               <FaTrash />
//             </IconButton>
//           </div>
//         ))}
//         <PrimaryGhost onClick={() => addArrayItem("termsAndConditions", { point: "" })}>
//           <FaPlus /> Add Point
//         </PrimaryGhost>
//       </Section>

//       {/* Other Details */}
//       <Section title="Other Details">
//         <div className={AD.formGrid2}>
//           <Select
//             label="Status"
//             value={form.status}
//             onChange={(v) => onChange("status", v)}
//             options={["Upcoming", "Live"]}
//           />
//           <Input label="Remark" value={form.remark} onChange={(v) => onChange("remark", v)} />
//           <Input
//             label="Age Restriction"
//             type="number"
//             value={form.ageRestriction}
//             onChange={(v) => onChange("ageRestriction", v)}
//           />
//           <Input label="Language" value={form.language} onChange={(v) => onChange("language", v)} />
//           <Input
//             label="Duration (minutes)"
//             type="number"
//             value={form.duration}
//             onChange={(v) => onChange("duration", v)}
//           />
//         </div>

//         {/* Toggles */}
//         <div className="mt-3 grid gap-3 sm:grid-cols-3">
//           <Toggle
//             label="Premium"
//             checked={form.isVerified}
//             onChange={(v) => onChange("isVerified", v)}
//           />
//           <Toggle
//             label="Booking Open"
//             checked={form.isBookingOpen}
//             onChange={(v) => onChange("isBookingOpen", v)}
//           />
//           <Toggle
//             label="Active"
//             checked={form.isActived}
//             onChange={(v) => onChange("isActived", v)}
//           />
//         </div>
//       </Section>

//       {/* Sticky footer actions */}
//       <div className="sticky bottom-3 z-10">
//         <div className="rounded-2xl border bg-white/90 backdrop-blur p-3 shadow-md flex items-center gap-3">
//           <button
//             type="submit"
//             className={cn(
//               "rounded-full bg-gradient-to-r from-yellow-400 to-yellow-500 px-6 py-2.5 text-sm font-semibold text-slate-900 hover:from-yellow-500 hover:to-yellow-600 transition-all",
//               loading && "opacity-60 cursor-wait"
//             )}
//             disabled={loading}
//           >
//             {loading ? (
//               <span className="inline-flex items-center gap-2">
//                 <FaSpinner className="animate-spin" /> Submitting…
//               </span>
//             ) : (
//               "Create Event"
//             )}
//           </button>

//           {loading ? (
//             <span className="text-sm text-slate-600 flex items-center gap-2">
//               <FaSpinner className="animate-spin" /> Please wait
//             </span>
//           ) : form.name && form.imageUrl ? (
//             <span className="text-sm text-emerald-600 flex items-center gap-2">
//               <FaCheckCircle /> Ready to publish
//             </span>
//           ) : (
//             <span className="text-sm text-slate-500 flex items-center gap-2">
//               <FaTimesCircle /> Add name & poster to proceed
//             </span>
//           )}
//         </div>
//       </div>
//     </form>
//   );
// }

// /* ========================= small bits ========================= */
// function Section({ title, hint, children }) {
//   return (
//     <div className="rounded-2xl border border-amber-100/70 bg-white/70 p-5 shadow-sm">
//       <div className="mb-3">
//         <h2 className="text-lg font-bold text-slate-900">{title}</h2>
//         {hint && <p className="text-xs text-slate-500">{hint}</p>}
//       </div>
//       <div className="space-y-4">{children}</div>
//     </div>
//   );
// }

// function Label({ children }) {
//   return <label className="block font-semibold text-slate-700">{children}</label>;
// }

// function Input({ label, value, onChange, type = "text", required = false, placeholder, min, disabled }) {
//   return (
//     <div>
//       <Label>
//         {label}
//         {required && <span className="text-rose-500"> *</span>}
//       </Label>
//       <input
//         type={type}
//         className={`mt-1 border w-full rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-300 disabled:opacity-60`}
//         value={value}
//         min={min}
//         onChange={(e) => onChange(e.target.value)}
//         required={required}
//         placeholder={placeholder}
//         aria-label={label}
//         disabled={disabled}
//       />
//     </div>
//   );
// }

// function Textarea({ label, value, onChange, rows = 4, placeholder }) {
//   return (
//     <div>
//       <Label>{label}</Label>
//       <textarea
//         className="mt-1 border w-full rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-300"
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         rows={rows}
//         placeholder={placeholder}
//         aria-label={label}
//       />
//     </div>
//   );
// }

// function Select({ label, value, onChange, options = [], disabled }) {
//   return (
//     <div>
//       <Label>{label}</Label>
//       <div className="relative mt-1">
//         <select
//           className="w-full appearance-none rounded-xl border px-3 py-2.5 pr-9 focus:ring-2 focus:ring-amber-300 disabled:opacity-60"
//           value={value}
//           onChange={(e) => onChange(e.target.value)}
//           aria-label={label}
//           disabled={disabled}
//         >
//           {options.map((opt) => (
//             <option key={opt} value={opt}>
//               {opt}
//             </option>
//           ))}
//         </select>
//         <svg
//           className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
//           width="16"
//           height="16"
//           viewBox="0 0 24 24"
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="1.8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         >
//           <path d="M6 9l6 6 6-6" />
//         </svg>
//       </div>
//     </div>
//   );
// }

// function Uploader({ label, progress, onFile, previewUrl, onClear, inputId }) {
//   const id = inputId || `uploader-${label.replace(/\s+/g, "-").toLowerCase()}`;
//   return (
//     <div>
//       <Label>{label}</Label>
//       <div className="mt-2 flex flex-col md:flex-row items-start md:items-center gap-3">
//         <input id={id} type="file" accept={ACCEPTED_IMG.join(",")} className="hidden" onChange={onFile} />
//         <label
//           htmlFor={id}
//           className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold hover:bg-slate-50 cursor-pointer"
//         >
//           {progress ? <FaSpinner className="animate-spin" /> : <FaUpload />}
//           {progress ? "Uploading…" : "Upload"}
//         </label>

//         {previewUrl ? (
//           <>
//             <img src={previewUrl} alt="preview" className="h-16 w-24 object-cover rounded border" />
//             <IconButton label="Remove" onClick={onClear}>
//               <FaTrash />
//             </IconButton>
//           </>
//         ) : (
//           <div className="h-16 w-24 grid place-items-center rounded border text-slate-400">
//             <FaImage />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// function Toggle({ label, checked, onChange }) {
//   return (
//     <div className="flex items-center justify-between rounded-xl border px-4 py-3 bg-white">
//       <div className="text-sm font-semibold text-slate-800">{label}</div>
//       <label className="relative inline-flex items-center cursor-pointer">
//         <input
//           type="checkbox"
//           checked={checked}
//           onChange={(e) => onChange(e.target.checked)}
//           className="sr-only peer"
//         />
//         <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
//           <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
//         </div>
//       </label>
//     </div>
//   );
// }

// function IconButton({ children, onClick, label }) {
//   return (
//     <button
//       type="button"
//       title={label}
//       aria-label={label}
//       onClick={onClick}
//       className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-slate-50"
//     >
//       {children}
//     </button>
//   );
// }

// function DangerButton({ children, onClick }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="inline-flex items-center gap-2 rounded-full border border-rose-300 text-rose-600 px-3 py-2 text-sm font-semibold hover:bg-rose-50"
//     >
//       {children}
//     </button>
//   );
// }

// function PrimaryGhost({ children, onClick }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-amber-50"
//     >
//       {children}
//     </button>
//   );
// }

// function GhostButton({ children, onClick }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="inline-flex items-center gap-2 text-amber-700 hover:text-amber-900"
//     >
//       {children}
//     </button>
//   );
// }

// function capitalize(s = "") {
//   return s.charAt(0).toUpperCase() + s.slice(1);
// }


import React, { useEffect, useMemo, useRef, useState } from "react";
import { API } from "../../../config/api";
import { post } from "../../../lib/http";
import {
  FaPlus,
  FaTrash,
  FaSpinner,
  FaCheckCircle,
  FaTimesCircle,
  FaUpload,
  FaImage,
  FaMapMarkerAlt,
  FaCrosshairs,
  FaSearch,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import RichText from "./RichText";
import { AD, focusAdminField } from "../../adminUi.js";

/* --------------------------- helpers --------------------------- */
const toDTLocal = (d) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
};
const cn = (...a) => a.filter(Boolean).join(" ");
const ACCEPTED_IMG = ["image/jpeg", "image/png", "image/webp"];
const MAX_IMG_MB = 5;

// Small debounce hook for typeahead
function useDebouncedValue(value, ms = 300) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

// Nominatim helpers (free; please keep requests light to respect usage policy)
const NOMINATIM_BASE = "https://nominatim.openstreetmap.org";

// normalize nominatim -> our venue shape
function normalizeAddress(osm) {
  const a = osm?.address || {};
  const city = a.city || a.town || a.village || a.hamlet || "";
  const state = a.state || a.region || "";
  const country = a.country || "";
  const pincode = a.postcode || "";
  const name = a.neighbourhood || a.suburb || a.quarter || a.road || a.residential || "";
  // "address" field we’ll store as display_name (human friendly, editable)
  const address = osm?.display_name || "";
  return {
    name,
    address,
    city,
    state,
    country,
    pincode,
    latitude: String(osm?.lat || ""),
    longitude: String(osm?.lon || ""),
  };
}

async function nominatimSearch(q, { limit = 5, lang = "en" } = {}) {
  if (!q?.trim()) return [];
  const url = `${NOMINATIM_BASE}/search?format=jsonv2&q=${encodeURIComponent(
    q
  )}&addressdetails=1&limit=${limit}&accept-language=${encodeURIComponent(lang)}`;
  const res = await fetch(url, { headers: { "Accept": "application/json" } });
  if (!res.ok) throw new Error("Search failed");
  return res.json();
}

async function nominatimReverse(lat, lon, { lang = "en" } = {}) {
  const url = `${NOMINATIM_BASE}/reverse?format=jsonv2&lat=${encodeURIComponent(
    lat
  )}&lon=${encodeURIComponent(lon)}&addressdetails=1&accept-language=${encodeURIComponent(lang)}`;
  const res = await fetch(url, { headers: { "Accept": "application/json" } });
  if (!res.ok) throw new Error("Reverse failed");
  return res.json();
}

/* ========================= component ========================== */
export default function AdminEventForm() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    category: "Music",
    description: "",
    venue: {
      name: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      latitude: "",
      longitude: "",
      capacity: "",
      logoUrl: "",
    },
    date: "",
    eventEndDate: "",
    ticketCategories: [
      {
        type: "",
        price: "",
        currency: "INR",
        totalSeats: "",
        availableSeats: "",
        perks: [""],
        isTicketAvailable: true,
      },
    ],
    showtimes: [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
    imageUrl: "",
    landsacpImage: [""],
    layoutImage: "",
    status: "Upcoming",
    organizer: { name: "", contactEmail: "", contactPhone: "", website: "", logoUrl: "" },
    termsAndConditions: [{ point: "" }],
    ratings: { averageRating: 0, totalReviews: 0 },
    isVerified: false,
    isBookingOpen: true,
    isActived: true,
    remark: "",
    tags: [""],
    sponsors: [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
    ageRestriction: "",
    language: "",
    duration: "",
    gstRateRaw: "",                // raw shown in UI (percent like "18")
    gstRate: "",                   // processed numeric (0.18)
    conveniencesFeeType: "convenienceFeeFlat", // selected option
    conveniencesFeeValueRaw: "",   // raw shown in UI (like "50" or "10")
    convenienceFeeFlat: "",       // processed if flat (numeric)
    convenienceFeePercent: ""
  });

  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});

  const onFormChange = (key, value) => {
    setForm((prev) => {
      const updated = { ...prev };

      // GST raw -> store raw and processed (divide by 100 for backend)
      if (key === "gstRate") {
        updated.gstRateRaw = value === "" ? "" : value; // UI display
        const n = parseFloat(value);
        updated.gstRate = !isNaN(n) && value !== "" ? n / 100 : ""; // processed numeric
        return updated;
      }

      // Conveniences fee type dropdown changed
      if (key === "conveniencesFeeType") {
        const newType = value; // "convenienceFeeFlat" or "convenienceFeePercent"

        // remove both processed keys first to avoid stale data
        delete updated.convenienceFeeFlat;
        delete updated.convenienceFeePercent;

        updated.conveniencesFeeType = newType;
        // keep the existing raw value (if any)
        const raw = prev.conveniencesFeeValueRaw ?? "";

        updated.conveniencesFeeValueRaw = raw;

        // set corresponding processed value depending on selected type
        const parsed = parseFloat(raw);
        if (newType === "convenienceFeePercent") {
          updated.convenienceFeePercent =
            !isNaN(parsed) && raw !== "" ? parsed / 100 : "";
          updated.convenienceFeeFlat = "";
        } else {
          // flat
          updated.convenienceFeeFlat = !isNaN(parsed) && raw !== "" ? parsed : "";
          updated.convenienceFeePercent = "";
        }
        return updated;
      }

      // Conveniences fee value input
      if (key === "conveniencesFeeValue") {
        updated.conveniencesFeeValueRaw = value === "" ? "" : value;
        const parsed = parseFloat(value);
        if (prev.conveniencesFeeType === "convenienceFeePercent") {
          updated.convenienceFeePercent =
            !isNaN(parsed) && value !== "" ? parsed / 100 : "";
          updated.convenienceFeeFlat = "";
        } else {
          // flat
          updated.convenienceFeeFlat = !isNaN(parsed) && value !== "" ? parsed : "";
          updated.convenienceFeePercent = "";
        }
        return updated;
      }

      // fallback for other fields
      updated[key] = value;
      return updated;
    });
  };


  // date min: tomorrow 00:00
  const now = new Date();
  const startOfTomorrow = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1,
    0,
    0,
    0
  );
  const minEventDate = toDTLocal(startOfTomorrow);

  /* --------------------------- setters --------------------------- */
  const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));
  const onNestedChange = (parent, key, value) =>
    setForm((f) => ({ ...f, [parent]: { ...f[parent], [key]: value } }));

  const onArrayChange = (arrKey, index, key, value) => {
    const updated = [...form[arrKey]];
    updated[index][key] = value;
    setForm((f) => ({ ...f, [arrKey]: updated }));
  };
  const addArrayItem = (arrKey, newItem) =>
    setForm((f) => ({ ...f, [arrKey]: [...f[arrKey], newItem] }));
  const removeArrayItem = (arrKey, index) =>
    setForm((f) => ({ ...f, [arrKey]: f[arrKey].filter((_, i) => i !== index) }));

  /* ------------------------- upload utils ------------------------ */
  const uploadFileAndGetUrl = async (file, progressKey = "file") => {
    if (!file) return "";
    if (!ACCEPTED_IMG.includes(file.type)) {
      toast.warn("Please upload JPG/PNG/WEBP image.");
      return "";
    }
    if (file.size > MAX_IMG_MB * 1024 * 1024) {
      toast.warn(`Image must be under ${MAX_IMG_MB} MB.`);
      return "";
    }

    const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
    const fd = new FormData();
    fd.append("file", file);

    try {
      setUploadProgress((p) => ({ ...p, [progressKey]: 1 }));
      const resp = await post(API.events.fileUploader, fd, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "multipart/form-data",
        },
      });
      const url =
        resp?.url ||
        resp?.resp?.url ||
        resp?.fileUrl ||
        resp?.location ||
        resp?.path ||
        resp?.secure_url ||
        "";

      if (!url) throw new Error("Upload success but no URL returned.");
      toast.success("Image uploaded ✅");
      return url;
    } catch (e) {
      console.error(e);
      toast.error("Upload failed ❌");
      return "";
    } finally {
      setUploadProgress((p) => ({ ...p, [progressKey]: 0 }));
    }
  };

  const handlePosterFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const url = await uploadFileAndGetUrl(file, "poster");
    if (url) onChange("imageUrl", url);
  };

  const handleLandscapeFile = async (e, index) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const url = await uploadFileAndGetUrl(file, `landscape-${index}`);
    if (url) {
      const imgs = [...form.landsacpImage];
      imgs[index] = url;
      onChange("landsacpImage", imgs);
    }
  };

  const handleLayoutImageFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const url = await uploadFileAndGetUrl(file, "layout"); // progressKey "layout"
    if (url) onChange("layoutImage", url);
  };

  const handleSponsorLogoFile = async (e, index) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const url = await uploadFileAndGetUrl(file, `sponsor-${index}`);
    if (url) onArrayChange("sponsors", index, "logo", url);
  };

  const handleOrganizerLogoFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const url = await uploadFileAndGetUrl(file, "organizer");
    if (url) onNestedChange("organizer", "logoUrl", url);
  };

  const handleVenueLogoFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const url = await uploadFileAndGetUrl(file, "venue");
    if (url) onNestedChange("venue", "logoUrl", url);
  };

  /* --------------------------- submit ---------------------------- */
  const validate = () => {
    const fail = (message, field) => {
      toast.warn(message);
      focusAdminField(field);
      return false;
    };
    if (!form.name.trim()) return fail("Please enter event name.", "name");
    if (!form.date) return fail("Please select event date.", "date");
    if (new Date(form.date) < startOfTomorrow) return fail("Event date must be after today.", "date");
    if (!form.venue.city.trim()) return fail("Please enter venue city.", "venue.city");
    if (!form.ticketCategories?.length) return fail("Add at least one ticket category.", "ticketCategories");
    const hasAnyAvailable = form.ticketCategories.some((t) => t.isTicketAvailable);
    if (!hasAnyAvailable) return fail("At least one ticket type must be available for booking.", "ticketCategories");
    return true;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
      const res = await post(API.events.createEvent, form, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      });
      console.log("Created event:", res);
      setTimeout(() => navigate("/admin/events"), 1200);
      toast.success("Event created successfully ✅");
    } catch (err) {
      console.error(err);
      toast.error("Failed to create event ❌");
    } finally {
      setLoading(false);
    }
  };

  /* ----------------------------- UI ----------------------------- */
  return (
    <form
      onSubmit={onSubmit}
      className={cn(AD.formWrapWide, AD.formSurfaceMuted, "space-y-6")}
    >
      {/* Header */}
      <div className={AD.formHeader}>
        <div>
          <h1 className={AD.title}>Create event</h1>
          <p className={AD.subtitle}>
            Add all details, images, tickets and partners—then publish.
          </p>
        </div>
        <span
          className={cn(
            "rounded-full px-3 py-1 text-xs font-semibold",
            form.isActived ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-700"
          )}
        >
          {form.isActived ? "Active" : "Inactive"}
        </span>
      </div>

      {/* Basic Info */}
      <Section title="Basic Info" hint="General details and primary schedule.">
        <div className={AD.formGrid2}>
          <Input
            label="Event Name"
            field="name"
            value={form.name}
            onChange={(v) => onChange("name", v)}
            required
            placeholder="e.g. Sunburn Arena"
          />
          <Select
            label="Category"
            value={form.category}
            onChange={(v) => onChange("category", v)}
            options={[
              "Music",
              "Theatre",
              "Comedy",
              "Dance",
              "Sports",
              "Exhibition",
              "Festival",
              "Conference",
              "Workshop",
              "Other",
            ]}
          />
        </div>

        {/* Rich text editor for description */}
        <RichText
          label="Description"
          value={form.description}
          onChange={(html) => onChange("description", html)}
          placeholder="What’s special about this event? Add details, headliners, schedule, FAQs, etc."
          minHeight={260}
        />

        <div className={AD.formGrid2}>
          <Input
            label="Event Date"
            field="date"
            type="datetime-local"
            value={form.date}
            onChange={(v) => {
              const picked = new Date(v);
              if (picked < startOfTomorrow) {
                toast.warn("Event date must be after today.");
                focusAdminField("date");
                return;
              }
              onChange("date", v);
            }}
            required
            min={minEventDate}
          />
          <Input
            label="Event End Date (optional)"
            type="datetime-local"
            value={form.eventEndDate}
            onChange={(v) => onChange("eventEndDate", v)}
            min={form.date || minEventDate}
          />
        </div>
      </Section>

      {/* Venue */}
      <Section title="Venue" hint="Search address or use current location (free via OpenStreetMap).">
        {/* NEW: Address picker (search + use my location) */}
        <AddressPicker
          value={form.venue}
          onPick={(patch) => {
            // patch contains address, city, state, country, pincode, latitude, longitude (and maybe name)
            Object.entries(patch).forEach(([k, v]) => onNestedChange("venue", k, v ?? ""));
            toast.success("Address filled from map ✅");
          }}
        />

        <div className={AD.formGrid2}>
          {["name", "address", "city", "state", "country", "pincode", "latitude", "longitude", "capacity"]
            .map((k) => (
              <Input
                key={k}
                label={capitalize(k)}
                field={`venue.${k}`}
                value={form.venue[k]}
                onChange={(v) => onNestedChange("venue", k, v)}
                type={["latitude", "longitude", "capacity"].includes(k) ? "number" : "text"}
              />
            ))}
        </div>

        <Uploader
          label="Venue Logo"
          progress={uploadProgress["venue"] > 0}
          onFile={handleVenueLogoFile}
          previewUrl={form.venue.logoUrl}
          onClear={() => onNestedChange("venue", "logoUrl", "")}
        />
      </Section>

      {/* Tickets */}
      <Section title="Ticket Categories" hint="Types, prices and perks.">
        {form.ticketCategories.map((t, i) => (
          <div
            key={i}
            className="rounded-xl border border-amber-100/80 bg-amber-50/40 p-4 dark:border-amber-900/30 dark:bg-amber-950/20"
            data-admin-field={i === 0 ? "ticketCategories" : undefined}
            tabIndex={i === 0 ? -1 : undefined}
          >
            <div className={AD.formGrid2}>
              <Input
                label="Type"
                value={t.type}
                onChange={(v) => onArrayChange("ticketCategories", i, "type", v)}
                placeholder="e.g. VIP / Gold / GA"
              />
              <Input
                label="Price (₹)"
                type="number"
                value={t.price}
                onChange={(v) => onArrayChange("ticketCategories", i, "price", v)}
                disabled={!t.isTicketAvailable}
              />
              <Input
                label="Currency"
                value={t.currency}
                onChange={(v) => onArrayChange("ticketCategories", i, "currency", v)}
                disabled={!t.isTicketAvailable}
              />
              <Input
                label="Total Seats"
                type="number"
                value={t.totalSeats}
                onChange={(v) => onArrayChange("ticketCategories", i, "totalSeats", v)}
                disabled={!t.isTicketAvailable}
              />
              <Input
                label="Available Seats"
                type="number"
                value={t.availableSeats}
                onChange={(v) => onArrayChange("ticketCategories", i, "availableSeats", v)}
                disabled={!t.isTicketAvailable}
              />
            </div>

            <div className="mt-3 grid sm:grid-cols-2 gap-3">
              <Toggle
                label="Tickets Available"
                checked={!!t.isTicketAvailable}
                onChange={(v) => onArrayChange("ticketCategories", i, "isTicketAvailable", v)}
              />
            </div>

            <div className="mt-4">
              <Label>Perks</Label>
              {t.perks.map((perk, j) => (
                <div key={j} className="flex items-center gap-2 mb-2">
                  <input
                    className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
                    value={perk}
                    onChange={(e) => {
                      const updated = [...t.perks];
                      updated[j] = e.target.value;
                      onArrayChange("ticketCategories", i, "perks", updated);
                    }}
                    placeholder="Add a perk…"
                    disabled={!t.isTicketAvailable}
                  />
                  <IconButton
                    label="Remove Perk"
                    onClick={() => {
                      const updated = t.perks.filter((_, idx) => idx !== j);
                      onArrayChange("ticketCategories", i, "perks", updated);
                    }}
                  >
                    <FaTrash />
                  </IconButton>
                </div>
              ))}
              <GhostButton
                onClick={() =>
                  onArrayChange("ticketCategories", i, "perks", [...t.perks, ""])
                }
              >
                <FaPlus /> Add Perk
              </GhostButton>
            </div>

            <div className="mt-3">
              <DangerButton onClick={() => removeArrayItem("ticketCategories", i)}>
                <FaTrash /> Remove Ticket
              </DangerButton>
            </div>
          </div>
        ))}

        <PrimaryGhost
          onClick={() =>
            addArrayItem("ticketCategories", {
              type: "",
              price: "",
              currency: "INR",
              totalSeats: "",
              availableSeats: "",
              perks: [""],
              isTicketAvailable: true,
            })
          }
        >
          <FaPlus /> Add Ticket
        </PrimaryGhost>
      </Section>

      <Section title="GST" hint="Enter GST details for the event.">
        <div className="flex items-center gap-2 mb-2">
          {/* GST */}
          <input
            type="number"
            step="any"
            placeholder="Enter GST Rate (e.g. 18)"
            value={form.gstRateRaw ?? ""}
            onChange={(e) => onFormChange("gstRate", e.target.value)}
             className="border p-2 w-full rounded-md"
          />

          {/* Conveniences Fee Type */}
          <select
            value={form.conveniencesFeeType}
            onChange={(e) => onFormChange("conveniencesFeeType", e.target.value)}
             className="border p-2 rounded-md w-30"
          >
            <option value="convenienceFeeFlat">Conveniences Fee Flat</option>
            <option value="convenienceFeePercent">Conveniences Fee Percentage</option>
          </select>

          {/* Conveniences Fee Value */}
          <input
            type="number"
            step="any"
            placeholder={form.conveniencesFeeType === "convenienceFeePercent" ? "Enter % (e.g. 10)" : "Enter amount (e.g. 50)"}
            value={form.conveniencesFeeValueRaw ?? ""}
            onChange={(e) => onFormChange("conveniencesFeeValue", e.target.value)}
             className="border p-2 w-full rounded-md"
          />


        </div>
      </Section>

      {/* Showtimes */}
      <Section title="Showtimes" hint="Multiple slots for multi-show events.">
        {form.showtimes.map((s, i) => (
          <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
            <div className={AD.formGrid2}>
              <Input
                label="Start Time"
                type="datetime-local"
                value={s.startTime}
                onChange={(v) => onArrayChange("showtimes", i, "startTime", v)}
              />
              <Input
                label="End Time"
                type="datetime-local"
                value={s.endTime}
                onChange={(v) => onArrayChange("showtimes", i, "endTime", v)}
              />
              <Input
                label="Available Seats"
                type="number"
                value={s.availableSeats}
                onChange={(v) => onArrayChange("showtimes", i, "availableSeats", v)}
              />
              <Input
                label="Ticket Price (₹)"
                type="number"
                value={s.ticketPrice}
                onChange={(v) => onArrayChange("showtimes", i, "ticketPrice", v)}
              />
            </div>
            <div className="mt-3">
              <DangerButton onClick={() => removeArrayItem("showtimes", i)}>
                <FaTrash /> Remove Showtime
              </DangerButton>
            </div>
          </div>
        ))}

        <PrimaryGhost
          onClick={() =>
            addArrayItem("showtimes", {
              startTime: "",
              endTime: "",
              availableSeats: "",
              ticketPrice: "",
            })
          }
        >
          <FaPlus /> Add Showtime
        </PrimaryGhost>
      </Section>

      {/* Images */}
      <Section title="Images" hint="Poster and landscape gallery.">
        <Uploader
          label="Poster Image"
          progress={uploadProgress["poster"] > 0}
          onFile={handlePosterFile}
          previewUrl={form.imageUrl}
          onClear={() => onChange("imageUrl", "")}
        />

        <div className="mt-4 space-y-2">
          <Label>Landscape Images</Label>
          {form.landsacpImage.map((img, i) => (
            <div key={i} className="flex flex-col md:flex-row items-start md:items-center gap-3">
              <input
                className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
                placeholder="Paste image URL (optional)"
                value={img}
                onChange={(e) => {
                  const imgs = [...form.landsacpImage];
                  imgs[i] = e.target.value;
                  onChange("landsacpImage", imgs);
                }}
              />
              <div>
                <input
                  id={`landscape-upload-${i}`}
                  type="file"
                  accept={ACCEPTED_IMG.join(",")}
                  className="hidden"
                  onChange={(e) => handleLandscapeFile(e, i)}
                />
                <label
                  htmlFor={`landscape-upload-${i}`}
                  className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-slate-50 cursor-pointer"
                >
                  <FaUpload /> Upload
                </label>
              </div>
              <IconButton
                label="Remove Image"
                onClick={() => removeArrayItem("landsacpImage", i)}
              >
                <FaTrash />
              </IconButton>

              {img ? (
                <img src={img} alt={`Landscape ${i + 1}`} className="h-16 w-24 object-cover rounded border" />
              ) : (
                <div className="h-16 w-24 grid place-items-center rounded border text-slate-400">
                  <FaImage />
                </div>
              )}
            </div>
          ))}
          <PrimaryGhost onClick={() => onChange("landsacpImage", [...form.landsacpImage, ""])}>
            <FaPlus /> Add Landscape Image
          </PrimaryGhost>
        </div>
      </Section>

      <Section title="Layout / Seating Plan" hint="Upload a hall/ground layout image (optional).">
        <Uploader
          label="Layout Image"
          progress={uploadProgress["layout"] > 0}
          onFile={handleLayoutImageFile}
          previewUrl={form.layoutImage}
          onClear={() => onChange("layoutImage", "")}
        />

        {/* (Optional) URL input as well */}
        <div className="mt-3">
          <Label>Or paste image URL</Label>
          <input
            className="border p-2 w-full rounded-xl focus:ring-2 focus:ring-amber-300"
            placeholder="https://…"
            value={form.layoutImage}
            onChange={(e) => onChange("layoutImage", e.target.value)}
          />
        </div>
      </Section>

      {/* Organizer */}
      <Section title="Organizer" hint="Organizer details & branding.">
        <div className={AD.formGrid2}>
          {Object.keys(form.organizer)
            .filter((k) => k !== "logoUrl")
            .map((k) => (
              <Input
                key={k}
                label={capitalize(k)}
                value={form.organizer[k]}
                onChange={(v) => onNestedChange("organizer", k, v)}
              />
            ))}
        </div>
        <Uploader
          label="Organizer Logo"
          progress={uploadProgress["organizer"] > 0}
          onFile={handleOrganizerLogoFile}
          previewUrl={form.organizer.logoUrl}
          onClear={() => onNestedChange("organizer", "logoUrl", "")}
        />
      </Section>

      {/* Sponsors */}
      <Section title="Sponsors" hint="Add partner logos and types.">
        {form.sponsors.map((s, i) => (
          <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
            <div className={AD.formGrid2}>
              <Input
                label="Name"
                value={s.name}
                onChange={(v) => onArrayChange("sponsors", i, "name", v)}
              />
              <Select
                label="Type"
                value={s.type}
                onChange={(v) => onArrayChange("sponsors", i, "type", v)}
                options={[
                  "Title Sponsor",
                  "Presenting Sponsor",
                  "Powered By Sponsor",
                  "Associate Sponsor",
                  "Official Partner",
                  "Official Beverage Partner",
                  "Official Food Partner",
                  "Official Travel Partner",
                  "Official Airline Partner",
                  "Official Transport Partner",
                  "Official Hotel Partner",
                  "Official Hospitality Partner",
                  "Official Bank Partner",
                  "Official Insurance Partner",
                  "Official Payment Partner",
                  "Official Apparel Partner",
                  "Official Footwear Partner",
                  "Official Merchandise Partner",
                  "Official Electronics Partner",
                  "Official Technology Partner",
                  "Official Streaming Partner",
                  "Official Ticketing Partner",
                  "Official Education Partner",
                  "Official Telecom Partner",
                  "Venue Partner",
                  "Logistics Partner",
                  "Stage & Equipment Partner",
                  "Printing Partner",
                  "Security Partner",
                  "Decoration Partner",
                  "Photography Partner",
                  "Medical Partner",
                  "Gifts Partner",
                  "Print Media Partner",
                  "TV Media Partner",
                  "Radio Partner",
                  "Digital Media Partner",
                  "Outdoor Media Partner",
                  "Social Media Partner",
                  "Accommodation Partner",
                  "Catering Partner",
                  "Food & Beverage Partner",
                  "Lounge Partner",
                  "App Partner",
                  "WiFi Partner",
                  "Virtual Event Partner",
                  "AR/VR Partner",
                  "Gaming Partner",
                  "NGO Partner",
                  "Environmental Partner",
                  "Government Partner",
                  "Cultural Partner",
                ]}
              />
            </div>
            <Textarea
              label="Description"
              value={s.description}
              onChange={(v) => onArrayChange("sponsors", i, "description", v)}
              rows={3}
            />
            <Uploader
              label="Logo"
              progress={uploadProgress[`sponsor-${i}`] > 0}
              onFile={(e) => handleSponsorLogoFile(e, i)}
              previewUrl={s.logo}
              onClear={() => onArrayChange("sponsors", i, "logo", "")}
              inputId={`sponsor-logo-upload-${i}`}
            />
            <div className="mt-3">
              <DangerButton onClick={() => removeArrayItem("sponsors", i)}>
                <FaTrash /> Remove Sponsor
              </DangerButton>
            </div>
          </div>
        ))}
        <PrimaryGhost
          onClick={() =>
            addArrayItem("sponsors", {
              name: "",
              logo: "",
              description: "",
              type: "Title Sponsor",
            })
          }
        >
          <FaPlus /> Add Sponsor
        </PrimaryGhost>
      </Section>

      {/* Terms & Conditions */}
      <Section title="Terms & Conditions" hint="Displayed on the event page.">
        {form.termsAndConditions.map((t, i) => (
          <div key={i} className="flex items-center gap-2 mb-2">
            <input
              className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
              placeholder="Write a point…"
              value={t.point}
              onChange={(e) => onArrayChange("termsAndConditions", i, "point", e.target.value)}
            />
            <IconButton label="Remove" onClick={() => removeArrayItem("termsAndConditions", i)}>
              <FaTrash />
            </IconButton>
          </div>
        ))}
        <PrimaryGhost onClick={() => addArrayItem("termsAndConditions", { point: "" })}>
          <FaPlus /> Add Point
        </PrimaryGhost>
      </Section>

      {/* Other Details */}
      <Section title="Other Details">
        <div className={AD.formGrid2}>
          <Select
            label="Status"
            value={form.status}
            onChange={(v) => onChange("status", v)}
            options={["Upcoming", "Live", "Ended", "Cancelled", "Past"]}
          />


          <Input label="Remark" value={form.remark} onChange={(v) => onChange("remark", v)} />
          <Input
            label="Age Restriction"
            type="number"
            value={form.ageRestriction}
            onChange={(v) => onChange("ageRestriction", v)}
          />
          <Input label="Language" value={form.language} onChange={(v) => onChange("language", v)} />
          <Input
            label="Duration (minutes)"
            type="number"
            value={form.duration}
            onChange={(v) => onChange("duration", v)}
          />
        </div>

        {/* Toggles */}
        <div className="mt-3 grid gap-3 sm:grid-cols-3">
          <Toggle
            label="Premium"
            checked={form.isVerified}
            onChange={(v) => onChange("isVerified", v)}
          />
          <Toggle
            label="Booking Open"
            checked={form.isBookingOpen}
            onChange={(v) => onChange("isBookingOpen", v)}
          />
          <Toggle
            label="Active"
            checked={form.isActived}
            onChange={(v) => onChange("isActived", v)}
          />
        </div>
      </Section>

      {/* Sticky footer actions */}
      <div className="sticky bottom-3 z-10">
        <div className="flex items-center gap-3 rounded-2xl border border-slate-200/90 bg-white/95 p-3 shadow-md backdrop-blur dark:border-gray-800 dark:bg-gray-900/90">
          <button
            type="submit"
            className={cn(AD.btnPrimary, loading && "cursor-wait opacity-60")}
            disabled={loading}
          >
            {loading ? (
              <span className="inline-flex items-center gap-2">
                <FaSpinner className="animate-spin" /> Submitting…
              </span>
            ) : (
              "Create event"
            )}
          </button>

          {loading ? (
            <span className="text-sm text-slate-600 flex items-center gap-2">
              <FaSpinner className="animate-spin" /> Please wait
            </span>
          ) : form.name && form.imageUrl ? (
            <span className="text-sm text-emerald-600 flex items-center gap-2">
              <FaCheckCircle /> Ready to publish
            </span>
          ) : (
            <span className="text-sm text-slate-500 flex items-center gap-2">
              <FaTimesCircle /> Add name & poster to proceed
            </span>
          )}
        </div>
      </div>
    </form>
  );
}

/* ========================= Address Picker ========================= */
function AddressPicker({ value, onPick }) {
  const [q, setQ] = useState(value?.address || "");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const debounced = useDebouncedValue(q, 300);
  const boxRef = useRef(null);

  useEffect(() => {
    setQ(value?.address || "");
  }, [value?.address]);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (!debounced || debounced.trim().length < 3) {
        setResults([]);
        return;
      }
      setLoading(true);
      try {
        const arr = await nominatimSearch(debounced, { limit: 6 });
        if (!alive) return;
        setResults(arr || []);
        setOpen(true);
      } catch (e) {
        console.error(e);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [debounced]);

  // click outside to close
  useEffect(() => {
    const onClick = (e) => {
      if (!boxRef.current) return;
      if (!boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const handlePick = (osm) => {
    const patch = normalizeAddress(osm);
    onPick?.(patch);
    setQ(patch.address || "");
    setOpen(false);
  };

  const useMyLocation = () => {
    if (!navigator.geolocation) {
      toast.warn("Geolocation not supported in this browser.");
      return;
    }
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          const { latitude, longitude } = pos.coords;
          const osm = await nominatimReverse(latitude, longitude);
          const patch = normalizeAddress(osm);
          onPick?.(patch);
          setQ(patch.address || "");
          toast.success("Fetched address from your location 📍");
        } catch (e) {
          console.error(e);
          toast.error("Failed to reverse geocode location.");
        } finally {
          setLoading(false);
          setOpen(false);
        }
      },
      (err) => {
        console.error(err);
        setLoading(false);
        toast.error("Could not access your location.");
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  return (
    <div className="relative" ref={boxRef}>
      <Label>Find Address</Label>
      <div className="mt-1 flex gap-2">
        <div className="relative flex-1">
          <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            className="pl-9 pr-3 py-2.5 w-full rounded-xl border focus:ring-2 focus:ring-amber-300"
            placeholder="Search place, venue, street…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onFocus={() => results.length && setOpen(true)}
          />
          {loading && (
            <FaSpinner className="absolute right-3 top-1/2 -translate-y-1/2 animate-spin text-slate-400" />
          )}
        </div>

        <button
          type="button"
          onClick={useMyLocation}
          className="inline-flex items-center gap-2 rounded-xl border px-3 py-2.5 text-sm font-semibold hover:bg-slate-50"
          title="Use my current location"
        >
          <FaCrosshairs /> Use my location
        </button>
      </div>

      {open && results.length > 0 && (
        <div className="absolute z-20 mt-1 w-full rounded-xl border bg-white shadow-lg max-h-64 overflow-auto">
          {results.map((r) => (
            <button
              type="button"
              key={`${r.place_id}-${r.lat}-${r.lon}`}
              onClick={() => handlePick(r)}
              className="w-full text-left px-3 py-2 hover:bg-amber-50"
            >
              <div className="flex items-start gap-2">
                <FaMapMarkerAlt className="mt-1 text-amber-600" />
                <div>
                  <div className="font-semibold text-slate-800">
                    {r.display_name?.split(",")?.[0] || "Place"}
                  </div>
                  <div className="text-xs text-slate-600 truncate">{r.display_name}</div>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

/* ========================= small bits ========================= */
function Section({ title, hint, children }) {
  return (
    <div className={cn(AD.formSurface, "transition-shadow hover:shadow-md")}>
      <div className="mb-3">
        <h2 className="text-base font-bold tracking-tight text-slate-900 dark:text-white">{title}</h2>
        {hint && <p className="text-xs text-slate-500 dark:text-slate-400">{hint}</p>}
      </div>
      <div className="space-y-4">{children}</div>
    </div>
  );
}

function Label({ children }) {
  return <label className={AD.fieldLabel}>{children}</label>;
}

function Input({ label, value, onChange, type = "text", required = false, placeholder, min, disabled, field }) {
  return (
    <div>
      <Label>
        {label}
        {required && <span className="text-rose-500"> *</span>}
      </Label>
      <input
        type={type}
        data-admin-field={field || undefined}
        className={cn("mt-1", AD.inputField, disabled && "cursor-not-allowed opacity-60")}
        value={value}
        min={min}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        placeholder={placeholder}
        aria-label={label}
        disabled={disabled}
      />
    </div>
  );
}

function Textarea({ label, value, onChange, rows = 4, placeholder, field }) {
  return (
    <div>
      <Label>{label}</Label>
      <textarea
        data-admin-field={field || undefined}
        className={cn("mt-1", AD.textareaField)}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={rows}
        placeholder={placeholder}
        aria-label={label}
      />
    </div>
  );
}

function Select({ label, value, onChange, options = [], disabled, field }) {
  return (
    <div>
      <Label>{label}</Label>
      <div className="relative mt-1">
        <select
          data-admin-field={field || undefined}
          className={cn(AD.select, disabled && "cursor-not-allowed opacity-60")}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label={label}
          disabled={disabled}
        >
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        <svg
          className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </div>
    </div>
  );
}

function Uploader({ label, progress, onFile, previewUrl, onClear, inputId }) {
  const id = inputId || `uploader-${label.replace(/\s+/g, "-").toLowerCase()}`;
  return (
    <div>
      <Label>{label}</Label>
      <div className="mt-2 flex flex-col md:flex-row items-start md:items-center gap-3">
        <input id={id} type="file" accept={ACCEPTED_IMG.join(",")} className="hidden" onChange={onFile} />
        <label
          htmlFor={id}
          className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold hover:bg-slate-50 cursor-pointer"
        >
          {progress ? <FaSpinner className="animate-spin" /> : <FaUpload />}
          {progress ? "Uploading…" : "Upload"}
        </label>

        {previewUrl ? (
          <>
            <img src={previewUrl} alt="preview" className="h-16 w-24 object-cover rounded border" />
            <IconButton label="Remove" onClick={onClear}>
              <FaTrash />
            </IconButton>
          </>
        ) : (
          <div className="h-16 w-24 grid place-items-center rounded border text-slate-400">
            <FaImage />
          </div>
        )}
      </div>
    </div>
  );
}

function Toggle({ label, checked, onChange }) {
  return (
    <div className={cn(AD.toggleRow, "py-2.5")}>
      <div className="text-sm font-semibold text-slate-800 dark:text-slate-100">{label}</div>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only peer"
        />
        <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
          <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
        </div>
      </label>
    </div>
  );
}

function IconButton({ children, onClick, label }) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      onClick={onClick}
      className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-slate-50"
    >
      {children}
    </button>
  );
}

function DangerButton({ children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-2 rounded-full border border-rose-300 text-rose-600 px-3 py-2 text-sm font-semibold hover:bg-rose-50"
    >
      {children}
    </button>
  );
}

function PrimaryGhost({ children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-amber-50"
    >
      {children}
    </button>
  );
}

function GhostButton({ children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-2 text-amber-700 hover:text-amber-900"
    >
      {children}
    </button>
  );
}

function capitalize(s = "") {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
